import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Header from '../../Common/Header/Header';
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup';
import FailurePopup from '../../Common/MessagePopup/FailurePopup';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import DatePicker from 'react-datepicker';
import { ChallengeDropDownDataType, CheckTheRhymeDataType, OptionDataType, TableChallengeDataType } from './ChallengeInterface';
import { createCongratsData, createKaraokeVideo, createQuestion, DeletAllChallengesByUnitId, deleteQuestionByQuestionId, GetAllChallenges, getKaraokeVideo, checkCongratulationData, updateCongratsData, updateKaraokeVideo, updateQuestion } from '../../../api/question';
import { getNewAccessToken } from '../../../api/auth';
import { setToken } from '../../../reducers/UserSplice';
import { IdAndName, LoadingDataType, MessageDataType } from '../../Common/Common/CommonInterface';
import { Action, QuestionCategory, QuestionType } from '../Unit-Intro/QuestionEnum';
import { getAllUnitByOffset, getUnitByUnitId, searchUnit } from '../../../api/unit';
import { Tooltip } from "react-tooltip";
import Loader from '../../Common/FullscreenLoader/FullScreenLoader';
import { Form } from 'react-bootstrap';
import CustomAlert from '../../Common/MessagePopup/CustomeAlert';
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup';
import { getGrade } from '../../../api/tribe';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import FullScreenLottieAnimation from '../../Common/LottieAnimation/FullScreenLottieAnimation';

const CheckTheRhyme = () => {
    const dispatch = useAppDispatch();
    const { access_token, refresh_token } = useAppSelector((state) => state.user.token);
    const [viewAllChallenges, setViewAllChallenges] = useState<boolean>(false);
    const [validated, setValidated] = useState<boolean>(false);
    const [tableChallengeData, setTableChallengeData] = useState<TableChallengeDataType[]>([]);
    const [tableData, setTableData] = useState<TableChallengeDataType>({
        id: "",
        unit: { id: "", name: "" },
        lesson: { id: "", name: "" },
        grade: { gradeId: "", gradeName: "" },
        subject: { id: "", name: "" },
        tribe: { id: "", name: "" },
        status: "",
    });

    const [activeFilter, setActiveFilter] = useState<{ status: string, grade: IdAndName }>({
        status: "",
        grade: { id: "", name: "" },
    });

    const [showKaraokeVideoInputField, setShowKaraokeVideoInputField] = useState<boolean>(false);
    const [showCongratulationsField, setShowCongratulationsField] = useState<boolean>(false);
    const [filter, setFilter] = useState<{ status: string, dateFilter: string, grade: string }>({ status: "", dateFilter: "", grade: "" })

    const [previewSource, setPreviewSource] = useState<string>("");
    const [dropDownList, setDropDownList] = useState<{ grade: IdAndName[] }>({
        grade: []
    })


    function removeSpans(html: string): string {
        // Remove opening span tags with attributes
        let cleaned = html.replace(/<span[^>]*>/g, "");
        // Remove closing span tags
        cleaned = cleaned.replace(/<\/span>/g, "");
        return cleaned;
    }

    const checkFileLimit = (file: File): boolean => {

        switch (file.type) {
            case "video/mp4":
            case "video/webm":
                return file.size <= 250 * 1024 * 1024; // 250 MB

            case "audio/wav":
            case "audio/mpeg": // standard MIME for mp3
                return file.size <= 20 * 1024 * 1024; // 20 MB

            case "image/png":
            case "image/jpeg": // covers both jpg & jpeg
            case "application/json":
            case "image/svg+xml":
                return file.size <= 20 * 1024 * 1024; // 20 MB

            default:
                // fallback (100 MB limit)
                return file.size <= 100 * 1024 * 1024;
        }
    };



    const handleOpenMedia = (file: any) => {
        if (file instanceof File) {
            const objectURL = URL.createObjectURL(file);
            setPreviewSource(objectURL);
        } else {
            setPreviewSource(file);
        }
    };


    const handleClosePreview = () => {
        setPreviewSource("");
    };


    //Challenges Variables
    const [allChallengeData, setAllChallengeData] = useState<CheckTheRhymeDataType[]>([]);
    const [dropdownList, setDropdownList] = useState<ChallengeDropDownDataType>({
        dropdownLevel: 0,
        dropdownUnit: [],
    })


    const [editCheckTheRhymeChallengeData, setEditCheckTheRhymeChallengeData] = useState<CheckTheRhymeDataType>({
        id: "",
        unit: { id: "", name: "" },
        grade: { gradeId: "", gradeName: "" },
        deletedOption: [],
        deleteS3Path: [],
        status: "",
        question: "",
        challengeMedia: {
            audioFile: { files: "", blobPath: "", fileExtension: "" },
            rhymeAudioFile: { files: "", blobPath: "", fileExtension: "" },
        },
        karaokeVideo: { id: "", files: "", blobPath: "", removeFiles: "" },
        checkTheRhyme: {
            RhymeText: "",
            Options: [{ id: "", media: { audio: { files: "", blobPath: "", fileExtension: "" } }, optionText: "", isAnswer: false }],
            MediaFile: {
                cardImageFile: { files: "", blobPath: "", fileExtension: "" }
            },
            flipRhymeText: "",
            hintText: "",
            reward: 0,
        },
        hint: { id: "", files: "", blobPath: "", removeFiles: "" },
        congratulation: {
            congratulationId: "",
            congratulationBadgeIcon: {
                files: "",
                blobPath: "",
                fileExtension: ""

            },
            congratulationAudio: {
                files: "",
                blobPath: "",
                fileExtension: ""

            },
            congratulationText: "",
            congratulationCoins: 0,
            deletedS3Path: [],
        }
    })
    const [addChallenges, setAddChallenges] = useState<boolean>(false);
    const [show, setShow] = useState(false);
    const [confirmationPopupData, setConfirmationPopupData] = useState({
        title: '',
        message: '',
        descriptions: '',
        acceptText: '',
        cancelText: '',
        onAccept: () => { },
        onCancel: () => { },
    });

    const [loading, setLoading] = useState<LoadingDataType>({
        fetchingLoading: false,
        tableLoading: false,
        deleteLoading: false,
        submitLoading: false,
        viewLoading: false,
        validationLoading: false,
    });
    const [message, setMessage] = useState<MessageDataType>({
        errorMessage: [],
        successMessage: '',
        failureMessage: '',
    });
    useEffect(() => {
        if (message.errorMessage.length > 0) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

    }, [message.errorMessage.length])
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [challengeCount, setChallengeCount] = useState<number>(0);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [searchtext, setSearchText] = useState<string>('');

    const indexOfLastItem = useMemo(() => currentPage * itemsPerPage, [currentPage, itemsPerPage]);
    const indexOfFirstItem = useMemo(() => indexOfLastItem - itemsPerPage, [indexOfLastItem, itemsPerPage]);


    const handleClose = useCallback(() => setShow(false), []);

    const handleTableChallengeData = useCallback((challengeData: any) => {
        try {
            const { units, count } = challengeData;
            setChallengeCount(count);

            const formattedData: TableChallengeDataType[] = units.map((unit: any) => {
                return {
                    id: unit.id,
                    unit: { id: unit.id, name: unit.name },
                    lesson: { id: unit.lesson.id, name: unit.lesson.name },
                    grade: { gradeId: unit.lesson.grade_id.id, gradeName: unit.lesson.grade_id.name },
                    subject: { id: unit.lesson.subject_id.id, name: unit.lesson.subject_id.name },
                    tribe: { id: unit.lesson.tribe_id.id, name: unit.lesson.tribe_id.name },
                    status: unit.isActive === 1 ? "PUBLISHED" : (unit.isActive === 2 ? "DRAFT" : "UNPUBLISHED"),
                };
            });
            setTableChallengeData(formattedData);
        } catch (error) {
            console.error('Handle Challenge Data Error:', error);
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    }, []);


    useEffect(() => {
        const handleSearch = async () => {

            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            setCurrentPage(1);
            if (startDate && endDate) {
                const lang = navigator.language || navigator.languages[0];
                setFilter({
                    ...filter,
                    dateFilter: `${startDate ? startDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""} - ${endDate ? endDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""
                        }`
                });
            }
            try {
                const searchTribeData = await searchUnit(searchtext, activeFilter.status, activeFilter.grade.id, (startDate && endDate) ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(indexOfLastItem), QuestionCategory.rhyme, access_token);

                const { data, statusCode } = searchTribeData;

                if (statusCode === 200) {
                    handleTableChallengeData(data);
                } else if (statusCode === 401) {
                    getAuthorizedToken();
                    setMessage({
                        ...message,
                        failureMessage: "Authorization token expired. Try again!"
                    })
                }
            } catch (error: any) {
                console.error("Search Error ::", error);
                if (error.response && error.response.data && typeof error.response.data === 'string') {
                    setMessage({
                        ...message,
                        failureMessage: error.response.data.message
                    })
                } else {
                    setMessage({
                        ...message,
                        failureMessage: "Something went wrong. Please try again"
                    })
                }
            } finally {
                setTimeout(() => {
                    setMessage(({
                        errorMessage: [],
                        successMessage: "",
                        failureMessage: ""
                    }))
                }, 2500)
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            }
        }

        handleSearch()

    }, [searchtext, activeFilter.status, activeFilter.grade.id, startDate, endDate])

    const getAuthorizedToken = useCallback(async () => {
        try {
            const newTokenResponse = await getNewAccessToken({ refreshToken: refresh_token });
            const { data, statusCode } = newTokenResponse;
            if (statusCode === 200) {
                dispatch(setToken({
                    access_token: data.accessToken,
                    refresh_token: data.refreshToken,
                }));
            }
        } catch (error: any) {
            console.error('Something went wrong in getting new access Token :: ', error);
        }
    }, [dispatch, refresh_token]);

    const getAllChallenges = useCallback(async (offset: number) => {

        setChallengeCount(0);
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        try {
            const challengeResponse = await searchUnit(searchtext, activeFilter.status, activeFilter.grade.id, (startDate && endDate) ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(indexOfLastItem), QuestionCategory.rhyme, access_token)
            const { data, statusCode } = challengeResponse;
            if (statusCode === 200) {
                handleTableChallengeData(data);
            } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage((prevMessage: MessageDataType) => ({
                    ...prevMessage,
                    failureMessage: 'Authorization token expired. Try again!',
                }));
            }
        } catch (error) {
            console.error('Get All Challenges Error:', error);
        }


    }, [access_token, getAuthorizedToken, handleTableChallengeData, currentPage]);

    const resetEditChallengeObject = () => {

        setEditCheckTheRhymeChallengeData({
            ...editCheckTheRhymeChallengeData,
            id: "",
            deletedOption: [],
            deleteS3Path: [],
            question: "",
            status: "",
            challengeMedia: {
                audioFile: { files: "", blobPath: "", fileExtension: "" },
                rhymeAudioFile: { files: "", blobPath: "", fileExtension: "" },
            },
            checkTheRhyme: {
                RhymeText: "",
                Options: [{ id: "", media: { audio: { files: "", blobPath: "", fileExtension: "" } }, optionText: "", isAnswer: false }],
                MediaFile: {
                    cardImageFile: { files: "", blobPath: "", fileExtension: "" }
                },
                flipRhymeText: "",
                hintText: "",
                reward: 0
            }
        })
    }

    const isLottieJson = (json: any): boolean => {
        return (
            typeof json === 'object' &&
            json !== null &&
            'v' in json &&
            'fr' in json &&
            'ip' in json &&
            'op' in json &&
            'layers' in json
        );
    };


    const handleCongratsInput = (e: React.ChangeEvent<HTMLInputElement> | null, name: string, value: string, isReplace: boolean) => {

        if (e) {
            const { files } = e.target;
            if (name === "congratulations-audio" || name === "congratulations-badge") {

                if (!files || files.length === 0) return;

                const file = files[0];

                if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
                    if (checkFileLimit(file)) {
                        setEditCheckTheRhymeChallengeData((prevData) => {
                            const updatedCongrats = { ...prevData.congratulation };
                            if (isReplace) {
                                if (!(updatedCongrats.congratulationAudio.files instanceof File)) {
                                    updatedCongrats.deletedS3Path = [
                                        ...updatedCongrats.deletedS3Path,
                                        updatedCongrats.congratulationAudio.files.replace(
                                            `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`,
                                            ""
                                        ),
                                    ];
                                }
                            }

                            updatedCongrats.congratulationAudio = {
                                files: file,
                                blobPath: URL.createObjectURL(file),
                                fileExtension: file.name.toLowerCase().split(".").pop() || "",
                            }

                            return {
                                ...prevData,
                                congratulation: updatedCongrats,
                            };
                        });

                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }

                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
                    });
                    return;
                }

            } else if (name === "congratulation-coins") {
                setEditCheckTheRhymeChallengeData((prevData) => ({
                    ...prevData,
                    congratulation: {
                        ...prevData.congratulation,
                        congratulationCoins: Number(value)
                    }
                }))
            }
        } else {
            if (name === "congratulation-text") {
                setEditCheckTheRhymeChallengeData((prevData) => ({
                    ...prevData,
                    congratulation: {
                        ...prevData.congratulation,
                        congratulationText: removeSpans(value)
                    }
                }))
            }
        }


    }


    const validateCongratsData = () => {
        let errorMessage: string[] = [];
        const isMediaValid = (media: any) => media && media.files;
        const { congratulation } = editCheckTheRhymeChallengeData;

        // if (congratulation.congratulationCoins <= 0) errorMessage.push("Coins should be greater than 0");
        if (!congratulation.congratulationText || congratulation.congratulationText.replace(/<[^>]*>/g, "").trim() === "") errorMessage.push("Please enter a valid congratulation text");
        // if (!isMediaValid(congratulation.congratulationBadgeIcon)) errorMessage.push("Please upload a valid badge icon");
        if (!isMediaValid(congratulation.congratulationAudio)) errorMessage.push("Please upload a valid congratulation audio");
        if (errorMessage.length > 0) {
            setMessage({
                ...message,
                errorMessage: errorMessage,
            });
            return false;
        } else {
            handleSubmitCongratsData();
        }
    }


    const getAllGrade = async () => {
        const gradeResponse = await getGrade();

        setDropDownList({
            grade: gradeResponse.data.data.map((grade: any) => ({
                id: grade.id,
                name: grade.name
            }))
        })

    }

    const formatLocalDate = (date: Date | null): string | null => {
        if (!date) return null; // Handle null case

        const localDate = new Date(date);
        localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Adjust for timezone shift

        return localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
    };

    useEffect(() => {
        if (!viewAllChallenges) {
            getAllChallenges(indexOfFirstItem);
            getAllGrade();
            setTableData({
                id: "",
                unit: { id: "", name: "" },
                lesson: { id: "", name: "" },
                grade: { gradeId: "", gradeName: "" },
                subject: { id: "", name: "" },
                tribe: { id: "", name: "" },
                status: "",
            })
        }
    }, [getAllChallenges, indexOfFirstItem, itemsPerPage, viewAllChallenges]);



    const handleEditChallenges = (challengeData: CheckTheRhymeDataType) => {
        setFilter({
            status: "",
            dateFilter: "",
            grade: ""
        })
        setActiveFilter({
            status: "",
            grade: { id: "", name: "" }
        })
        setStartDate(null)
        setEndDate(null);
        setSearchText("");

        setEditCheckTheRhymeChallengeData({
            ...editCheckTheRhymeChallengeData,
            id: challengeData.id,
            challengeMedia: challengeData.challengeMedia,
            checkTheRhyme: challengeData.checkTheRhyme,
            question: challengeData.question,
            deletedOption: challengeData.deletedOption,
            deleteS3Path: challengeData.deleteS3Path,
        });
    }

    const handleDeleteChallengeById = async (challengeId: string) => {
        setShow(true)
        setConfirmationPopupData({
            title: `Are you sure you want to delete?`,
            message: "This action cannot be undone.",
            descriptions: "",
            acceptText: "Delete",
            cancelText: "Cancel",
            onAccept: async () => {
                setShow(false)
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, viewLoading: false, validationLoading: false }));
                try {
                    await deleteQuestionByQuestionId(challengeId, access_token).then((deleteChallengeResponse) => {
                        const { data, statusCode } = deleteChallengeResponse;

                        if (statusCode === 200) {
                            setMessage({
                                ...message,
                                successMessage: "Challenge deleted successfully!"
                            })
                        } else if (statusCode === 401) {
                            getAuthorizedToken();
                            setMessage((prevMessage: MessageDataType) => ({
                                ...prevMessage,
                                failureMessage: 'Authorization token expired. Try again!',
                            }));
                        }
                    })
                } catch (error: any) {
                    if (error.response && error.response.data && typeof error.response.data === "string") {
                        setMessage({
                            ...message,
                            failureMessage: error.response.data.message
                        })
                    } else {
                        setMessage({
                            ...message,
                            failureMessage: "Something went wrong. Please try again"
                        })
                    }
                } finally {
                    resetEditChallengeObject();
                    setCurrentPage(1);
                    setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                    viewAllQuestion(editCheckTheRhymeChallengeData.unit.id);
                    setTimeout(() => {
                        setMessage({
                            ...message,
                            failureMessage: "",
                            successMessage: ""
                        });
                    }, 2500)
                }



            },
            onCancel: handleClose,
        })

    }

    const checkTheRhymeValidation = () => {
        const { unit, challengeMedia, karaokeVideo, congratulation, hint, checkTheRhyme } = editCheckTheRhymeChallengeData;
        let errorList = [];

        if (!viewAllChallenges) {
            if (!unit.id) {
                errorList.push("Select the valid unit");
            }
            if (showKaraokeVideoInputField) {
                if (!karaokeVideo.files) {
                    errorList.push("Upload the valid Karaoke Video.")
                }
            }
        }

        if (!checkTheRhyme.RhymeText.trim()) {
            errorList.push("Input valid check the rhyme text.");
        }

        // Common validation functions
        const validateArray = (arr: any, minLength: number, errorMsg: string) => {
            if (arr.length < minLength) {
                errorList.push(errorMsg);
            }
        };

        const validateText = (text: string, errorMsg: string) => {
            if (!text?.trim()) {
                errorList.push(errorMsg);
            }
        };

        validateArray(checkTheRhyme.Options, 2, "There should be at least 2 options");
        checkTheRhyme.Options.forEach((option: any) => validateText(option.optionText, "Option Text cannot be empty"));

        // Check if more than one option is marked as answer
        const answersCount = checkTheRhyme.Options.filter((option: any) => option.isAnswer).length;
        if (checkTheRhyme.Options.length > 1 && answersCount !== 1) {
            errorList.push("Exactly one option must be marked as the answer.");
        }

        if (checkTheRhyme.Options.some((option: OptionDataType) => !(option.media.audio.files))) {
            errorList.push("Each Options must have an VO audio.")
        }

        // Merged hint validation (text + animation)
        let hintErrors = [];
        if (!viewAllChallenges && showKaraokeVideoInputField && !hint.files) {
            hintErrors.push("hint animation");
        }
        if (!checkTheRhyme.hintText.trim()) {
            hintErrors.push("hint text");
        }
        if (hintErrors.length > 0) {
            errorList.push(`Input valid ${hintErrors.join(" and ")}.`);
        }

        // Merged flip rhyme validation (text + vo)
        let flipErrors = [];
        if (!checkTheRhyme.flipRhymeText.replace(/<[^>]*>/g, '').trim()) {
            flipErrors.push("flip rhyme text");
        }
        if (!challengeMedia.rhymeAudioFile.files) {
            flipErrors.push("flip rhyme VO");
        }
        if (flipErrors.length > 0) {
            errorList.push(`Upload valid ${flipErrors.join(" and ")}.`);
        }

        if (checkTheRhyme.reward <= 0) {
            errorList.push("Reward should be greater than 0");
        }

        if (!challengeMedia.audioFile.files) {
            errorList.push("Upload valid VO.");
        }

        // Merged congratulation validation (text + audio)
        if (!viewAllChallenges && showCongratulationsField) {
            let congratulationErrors = [];
            if (!congratulation.congratulationText.replace(/<[^>]*>/g, '').trim()) {
                congratulationErrors.push("congratulation text");
            }
            if (!congratulation.congratulationAudio.files) {
                congratulationErrors.push("congratulation VO");
            }
            if (congratulationErrors.length > 0) {
                errorList.push(`Input valid ${congratulationErrors.join(" and ")}.`);
            }
        }

        if (errorList.length > 0) {
            setMessage({
                ...message,
                errorMessage: errorList
            })
        } else {
            handleSubmit()
        }
    }

    const handleEndDateChange = (date: any) => {
        const currentDate = new Date(); // Get the current date

        if (!startDate) {
            setMessage({
                ...message,
                errorMessage: [
                    "Please select a start date before choosing the end date.",
                ],
            });
            return;
        }

        if (date < startDate) {
            setMessage({
                ...message,
                errorMessage: [
                    "The end date cannot be earlier than the start date. Please choose a valid end date.",
                ],
            });
            return;
        }

        if (date > currentDate) {
            setMessage({
                ...message,
                errorMessage: [
                    "The end date cannot be in the future. Please select a date that is today or earlier.",
                ],
            });
            return;
        }

        setEndDate(date);
    };

    const handleFilter = (name: string, value: string | IdAndName) => {
        if (name === "status" && typeof value === "string") {
            setActiveFilter(prev => ({
                ...prev,
                status: value ? value : ""
            }));

            setFilter(prev => ({
                ...prev,
                status: value === "1" ? "Published" : value === "2" ? "Draft" : value === "0" ? "Unpublished" : ""
            }));
        } else if (name === "grade" && typeof value === "object") {
            setActiveFilter(prev => ({
                ...prev,
                grade: value
            }));

            setFilter(prev => ({
                ...prev,
                grade: value.name
            }));
        } else if (name === "date") {
            setFilter({
                ...filter,
                dateFilter: ""
            })
            setStartDate(null)
            setEndDate(null)
        }
    };


    const handleAddCheckTheRhymeChallenge = async () => {
        if (!editCheckTheRhymeChallengeData.id) {
            setAddChallenges(true);
            if (!viewAllChallenges) {
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                try {
                    await getAllUnitByOffset("0", "10", true, access_token).then((response) => {
                        const { data, statusCode } = response;
                        if (statusCode === 200) {
                            setDropdownList({
                                ...dropdownList,
                                dropdownUnit: data.units.filter((unit: any) => unit.isActive !== 0).map((unit: any) => ({
                                    id: unit.id,
                                    name: unit.name,
                                }))
                            })
                        } else if (statusCode === 401) {
                            getAuthorizedToken();
                            setMessage({
                                ...message,
                                failureMessage: "Authorization token expired. Try again!"
                            })
                        }

                    })
                } catch (error: any) {
                    if (error.response && error.response.data && typeof error.response.data === "string") {
                        setMessage({
                            ...message,
                            failureMessage: error.response.data.message
                        })
                    } else {
                        setMessage({
                            ...message,
                            failureMessage: "Something went wrong. Please try again"
                        })
                    }
                } finally {
                    setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                }

            }
        } else {
            setMessage({
                errorMessage: ["Please save or cancel the challenge before adding new check the rhyme challenge."],
                successMessage: "",
                failureMessage: ""
            });
        }
    }

    const handleSubmit = async () => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, viewLoading: false, validationLoading: false }));
        const formData = new FormData();
        const KaraokeFormData = new FormData();
        const CongratsFormData = new FormData();
        const isEdit = !!editCheckTheRhymeChallengeData.id;

        const { id, grade, unit, checkTheRhyme, challengeMedia, deletedOption, } = editCheckTheRhymeChallengeData;

        const appendIfExists = (key: string, value: string | undefined) => {
            if (value && value.trim() !== "") formData.append(key, value);
        };

        const appendFileIfValid = (key: string, file: any) => {
            if (file instanceof File) {
                formData.append(key, file);
                return true;
            }
            return false;
        };

        // Common fields
        if (isEdit) formData.append("id", id);
        formData.append("difficulty_level_Id", "4");
        formData.append("grade_id", grade.gradeId);
        formData.append("unit_id", unit.id);
        formData.append("level", "1");
        formData.append("category", QuestionCategory.rhyme);
        formData.append("type", QuestionType.mcq);
        formData.append("action", Action.click);
        formData.append("question", checkTheRhyme.RhymeText);
        formData.append("reward", String(editCheckTheRhymeChallengeData.checkTheRhyme.reward))


        KaraokeFormData.append("grade_id", grade.gradeId);
        KaraokeFormData.append("unit_id", unit.id);
        if (editCheckTheRhymeChallengeData.karaokeVideo.files instanceof File) {
            KaraokeFormData.append("video_path", editCheckTheRhymeChallengeData.karaokeVideo.files);
        }
        if (editCheckTheRhymeChallengeData.hint.files instanceof File) {
            KaraokeFormData.append("hint_animation", editCheckTheRhymeChallengeData.hint.files)
        }


        CongratsFormData.append("difficulty_level_id", "4");
        CongratsFormData.append("grade_id", editCheckTheRhymeChallengeData.grade.gradeId);
        CongratsFormData.append("unit_id", editCheckTheRhymeChallengeData.unit.id);
        CongratsFormData.append("text", editCheckTheRhymeChallengeData.congratulation.congratulationText);

        CongratsFormData.append("challenge_type", "RHYME");

        if (editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files instanceof File) {
            CongratsFormData.append("audio_file_path", editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files);
        }


        appendIfExists("flip_rhyme_text", checkTheRhyme.flipRhymeText);
        appendIfExists("hint", checkTheRhyme.hintText);

        // Media
        appendFileIfValid("question_image", checkTheRhyme.MediaFile.cardImageFile.files);
        formData.append("image_exist", "false");
        formData.append("animation_exist", "false");

        appendFileIfValid("audio_file_path", challengeMedia.audioFile.files);
        formData.append("audio_exist", "true");

        appendFileIfValid("rhyme_voiceover_audio", challengeMedia.rhymeAudioFile.files);

        // Options
        const optionArray: any[] = [];
        const newOptionArray: any[] = [];
        const answerArray: string[] = [];



        if (isEdit) {
            const optionsWithId = checkTheRhyme.Options.filter(option => option.id);
            const optionsWithoutId = checkTheRhyme.Options.filter(option => !option.id);

            optionsWithId.forEach((option, index) => {
                optionArray.push({ id: option.id, optionText: option.optionText });
                if (option.media.audio.files instanceof File) {
                    formData.append("files", option.media.audio.files, `audio_option_${index}.${option.media.audio.fileExtension}`);
                }
                if (option.isAnswer) answerArray.push(option.optionText)

            });

            optionsWithoutId.forEach((option, index) => {
                newOptionArray.push({ optionText: option.optionText });
                if (option.media.audio.files instanceof File) {
                    formData.append("files", option.media.audio.files, `audio_new_option_${index}.${option.media.audio.fileExtension}`);
                }

                if (option.isAnswer) answerArray.push(option.optionText)
            });

        } else {

            editCheckTheRhymeChallengeData.checkTheRhyme.Options.forEach((option: OptionDataType) => {
                optionArray.push({ optionText: option.optionText });
                if (option.isAnswer) answerArray.push(option.optionText)

            })


            editCheckTheRhymeChallengeData.checkTheRhyme.Options.forEach((option: OptionDataType, optionIndex: number) => {
                option.media.audio.files && formData.append("files", option.media.audio.files, `audio_option_${optionIndex}.${option.media.audio.fileExtension}`)
            })
        }


        formData.append("options", JSON.stringify(optionArray));
        if (newOptionArray.length > 0) {
            formData.append("new_options", JSON.stringify(newOptionArray));
        }

        formData.append("answer", answerArray.join(","));


        if (deletedOption?.length > 0) {
            formData.append("delete_options", JSON.stringify(deletedOption.map(id => ({ id }))));
        }

        const submitAction = isEdit ? updateQuestion : createQuestion;

        try {
            if (!viewAllChallenges && !isEdit) {
                if (showKaraokeVideoInputField) {
                    const createResponse = await createKaraokeVideo(KaraokeFormData, access_token);

                    if (createResponse.statusCode === 200) {
                        setMessage({
                            ...message,
                            successMessage: "Karaoke Video created successfully!",
                        });
                        setEditCheckTheRhymeChallengeData(prev => ({
                            ...prev,
                            karaokeVideo: {
                                ...prev.karaokeVideo,
                                id: createResponse.data.id,
                                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${createResponse.data.video_path}`, // file path string
                                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${createResponse.data.video_path}`,
                                removeFiles: ""
                            },
                            hint: {
                                ...prev.hint,
                                id: createResponse.data.id,
                                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${createResponse.data.hint_animation}`, // file path string
                                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${createResponse.data.hint_animation}`,
                                removeFiles: ""
                            }
                        }))
                    }
                }

                if (showCongratulationsField) {
                    const createCongratulationsResponse = await createCongratsData(CongratsFormData, access_token);
                    if (createCongratulationsResponse.statusCode === 200) {
                        setMessage({
                            ...message,
                            successMessage: "Karaoke Video created successfully!",
                        });
                        setEditCheckTheRhymeChallengeData(prev => ({
                            ...prev,
                            congratulation: {
                                ...prev.congratulation,
                                congratulationId: createCongratulationsResponse.data.id,
                                congratulationText: createCongratulationsResponse.data.text,
                                congratulationAudio: {
                                    files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${createCongratulationsResponse.data.audio_file_path}`,
                                    blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${createCongratulationsResponse.data.audio_file_path}`,
                                    fileExtension: createCongratulationsResponse.data.audio_file_path.split('.').pop() || ""
                                }
                            }
                        }))
                    }
                }

            }


            const response = await submitAction(formData, access_token);
            const { data, statusCode } = response;

            if (statusCode === 200) {
                setMessage(prev => ({
                    ...prev,
                    successMessage: `Challenge ${isEdit ? "updated" : "added"} successfully!`
                }));
            } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage(prev => ({
                    ...prev,
                    failureMessage: "Authorization token expired. Try again!"
                }));
            }
        } catch (error: any) {
            const failureMessage = error?.response?.data?.message || "Something went wrong. Please try again.";
            setMessage(prev => ({ ...prev, failureMessage }));
        } finally {
            if (isEdit) resetEditChallengeObject();
            else {
                setAddChallenges(false);
                setViewAllChallenges(true);
            }
            setCurrentPage(1);
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, ...(isEdit ? {} : { viewLoading: true }), validationLoading: false }));

            viewAllQuestion(unit.id);
            setTimeout(() => {
                setMessage(prev => ({
                    ...prev,
                    failureMessage: "",
                    successMessage: ""
                }));
            }, 2500);
        }
    };

    useEffect(() => {
        console.log("Edit CTR ><> ", editCheckTheRhymeChallengeData)
    }, [editCheckTheRhymeChallengeData])

    const handleSubmitCongratsData = async () => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, viewLoading: false, validationLoading: false }));
        try {
            const formdata = new FormData();
            if (editCheckTheRhymeChallengeData.congratulation.congratulationId)
                formdata.append("id", editCheckTheRhymeChallengeData.congratulation.congratulationId)
            formdata.append("difficulty_level_id", "4");
            formdata.append("grade_id", editCheckTheRhymeChallengeData.grade.gradeId);
            formdata.append("unit_id", editCheckTheRhymeChallengeData.unit.id);
            formdata.append("text", editCheckTheRhymeChallengeData.congratulation.congratulationText);
            // formdata.append("reward", editCheckTheRhymeChallengeData.congratulation.congratulationCoins.toString());
            formdata.append("challenge_type", "RHYME");
            // if (editCheckTheRhymeChallengeData.congratulation.congratulationBadgeIcon.files instanceof File) {
            //     formdata.append("image_path", editCheckTheRhymeChallengeData.congratulation.congratulationBadgeIcon.files);
            // }

            if (editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files instanceof File) {
                formdata.append("audio_file_path", editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files);
            }

            if (editCheckTheRhymeChallengeData.congratulation.deletedS3Path.length > 0) {
                formdata.append("removeFiles", JSON.stringify(editCheckTheRhymeChallengeData.congratulation.deletedS3Path.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({ path: s3path.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, "") }))));
            }

            const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

            const getMediaObject = (path: string) => ({
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` || "",
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` || "",
                fileExtension: getFileExtension(path),
            });

            if (editCheckTheRhymeChallengeData.congratulation.congratulationId) {
                await updateCongratsData(formdata, access_token).then((updateResponse) => {
                    const { data, statusCode } = updateResponse;
                    if (statusCode === 200) {
                        setEditCheckTheRhymeChallengeData((prevData) => ({
                            ...prevData,
                            congratulation: {
                                congratulationId: data.id,
                                congratulationAudio: getMediaObject(data.audio_file_path),
                                congratulationText: data.text,
                                congratulationCoins: data.reward,
                                deletedS3Path: []
                            }
                        }));
                        setMessage({
                            ...message,
                            successMessage: "Congratulations updated successfully!"
                        });
                    } else if (statusCode === 401) {
                        getAuthorizedToken();
                        setMessage({
                            ...message,
                            failureMessage: "Authorization token expired. Try again!"
                        })
                    }

                });
            } else {
                await createCongratsData(formdata, access_token).then((createResponse) => {
                    const { data, statusCode } = createResponse;
                    if (statusCode === 200) {
                        setEditCheckTheRhymeChallengeData((prevData) => ({
                            ...prevData,
                            congratulation: {
                                congratulationId: data.id,
                                // congratulationBadgeIcon: getMediaObject(data.image_path),
                                congratulationAudio: getMediaObject(data.audio_file_path),
                                congratulationText: data.text,
                                congratulationCoins: data.reward,
                                deletedS3Path: []
                            }
                        }));
                        setMessage({
                            ...message,
                            successMessage: "Congratulations added successfully!"
                        });
                    } else if (statusCode === 401) {
                        getAuthorizedToken();
                        setMessage({
                            ...message,
                            failureMessage: "Authorization token expired. Try again!"
                        })
                    }
                });
            }
        } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                })
            } else {
                setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                })
            }
        } finally {
            setTimeout(() => {
                setMessage(((prev: MessageDataType) => {
                    const updatedData = { ...prev };
                    updatedData.errorMessage = prev.errorMessage;
                    updatedData.failureMessage = "";
                    updatedData.successMessage = ""
                    return updatedData
                }))

            }, 2500)
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }

    }


    const handleCancel = async () => {
        setShow(true)
        setConfirmationPopupData({
            title: `Are you sure you want to cancel?`,
            message: "This action cannot be undone.",
            descriptions: "",
            acceptText: "Yes",
            cancelText: "Cancel",
            onAccept: async () => {
                setShow(false);
                setAddChallenges(false);
                setEditCheckTheRhymeChallengeData({
                    ...editCheckTheRhymeChallengeData,
                    id: "",

                    unit: { id: "", name: "" },
                    deletedOption: [],
                    deleteS3Path: [],
                    question: "",
                    challengeMedia: {
                        audioFile: { files: "", blobPath: "", fileExtension: "" },
                        rhymeAudioFile: { files: "", blobPath: "", fileExtension: "" },
                    },
                    checkTheRhyme: {
                        RhymeText: "",
                        Options: [{ id: "", media: { audio: { files: "", blobPath: "", fileExtension: "" } }, optionText: "", isAnswer: false }],
                        MediaFile: {
                            cardImageFile: { files: "", blobPath: "", fileExtension: "" }
                        },
                        flipRhymeText: "",
                        hintText: "",
                        reward: 0
                    }
                })
                setCurrentPage(1);
                if (viewAllChallenges) {
                    viewAllQuestion(editCheckTheRhymeChallengeData.unit.id);
                } else {
                    getAllChallenges(indexOfFirstItem);

                }


            },
            onCancel: handleClose,
        })

    }

    useEffect(() => {
        if (!addChallenges) {
            resetEditChallengeObject();
            setCurrentPage(1)
            getAllChallenges(indexOfFirstItem);
        }
    }, [addChallenges])


    const handlePagination = useCallback(async (pageNumber: number, direction: string) => {
        if (pageNumber < 1 || pageNumber > Math.ceil(challengeCount / itemsPerPage)) {
            return; // Prevent navigation to invalid pages
        }

        try {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            if (direction === 'right' && pageNumber <= Math.ceil(challengeCount / itemsPerPage)) {
                setCurrentPage(pageNumber);
            } else if (direction === 'left' && pageNumber >= 1) {
                setCurrentPage(pageNumber);
            }
        } catch (error: any) {
            setMessage({
                ...message,
                failureMessage: "Something went wrong."
            })
            console.error(error)
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            setTimeout(() => {
                setMessage({
                    errorMessage: [],
                    successMessage: "",
                    failureMessage: ""
                })
            }, 2500)
        }
    }, [challengeCount, itemsPerPage]);

    const handleChallengeData = (challengeData: any) => {
        try {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            const { congratulationData, karaoke, questionData, count } = challengeData;

            setChallengeCount(count);

            try {
                const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

                const getMediaObject = (path: string) => ({
                    files: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
                    blobPath: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
                    fileExtension: getFileExtension(path),
                });

                if (karaoke) {
                    setEditCheckTheRhymeChallengeData(prev => ({
                        ...prev,
                        karaokeVideo: {
                            ...prev.karaokeVideo,
                            id: karaoke.id || "",
                            files: karaoke.video_path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${karaoke.video_path}` : "",
                            blobPath: karaoke.video_path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${karaoke.video_path}` : "",
                            removeFiles: ""
                        },
                        hint: {
                            ...prev.karaokeVideo,
                            id: karaoke.id || "",
                            files: karaoke.hint_animation ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${karaoke.hint_animation}` : "",
                            blobPath: karaoke.hint_animation ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${karaoke.hint_animation}` : "",
                            removeFiles: ""
                        }
                    }))
                }


                const congratulation = congratulationData
                    ? {
                        congratulationId: congratulationData.id,
                        // congratulationBadgeIcon: getMediaObject(congratulationData.image_path),
                        congratulationAudio: getMediaObject(congratulationData.audio_file_path),
                        congratulationText: congratulationData.text,
                        congratulationCoins: congratulationData.reward,
                        deletedS3Path: []
                    }
                    : {
                        congratulationId: "",
                        // congratulationBadgeIcon: getMediaObject(""),
                        congratulationAudio: getMediaObject(""),
                        congratulationText: "",
                        congratulationCoins: 0,
                        deletedS3Path: []
                    };
                const formattedData: CheckTheRhymeDataType[] = questionData.map((question: any) => ({
                    id: question.id,
                    deletedOption: [],
                    category: question.category === "RHYME",
                    question: question.question,
                    challengeMedia: {
                        audioFile: getMediaObject(question.audio_file_path ? question.audio_file_path : ""),
                        rhymeAudioFile: getMediaObject(question.rhyme_path ? question.rhyme_path : "")
                    },
                    // Conditionally include checkTheRhyme only if the category is "RHYME"
                    answer: question.answer,
                    checkTheRhyme: {
                        RhymeText: question.question,
                        Options: question.options.map((option: any) => ({
                            id: option.id,
                            media: {
                                audio: getMediaObject(option.audio_path ? option.audio_path : ""),
                            },
                            optionText: option.optionText,
                            isAnswer: question.answer.includes(option.optionText),
                        })),
                        MediaFile: {
                            cardImageFile: getMediaObject(question.image_path ? question.image_path : ""),
                            audioFile: getMediaObject(""),
                        },
                        flipRhymeText: question.flip_rhyme_text,
                        hintText: question.hint,
                        reward: question.reward ? Number(question.reward) : 0
                    },
                    deleteS3Path: [],
                }));
                setAllChallengeData(formattedData);
                setEditCheckTheRhymeChallengeData((prev) => ({
                    ...prev,
                    congratulation: congratulation
                }));
            } catch (error: any) {
                if (error.response && error.response.data && typeof error.response.data === "string") {
                    setMessage({
                        ...message,
                        failureMessage: error.response.data.message
                    })
                } else {
                    setMessage({
                        ...message,
                        failureMessage: "Something went wrong. Please try again"
                    })
                }
            }
            finally {
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            }




        } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                })
            } else {
                setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                })
            }
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    }



    const handleDropDownData = async (name: string, value: string) => {
        if (name === "challengeUnit") {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            try {
                await getUnitByUnitId(value, access_token).then(async (unitResponse) => {
                    const { data, statusCode } = unitResponse;
                    if (statusCode === 200) {
                        setEditCheckTheRhymeChallengeData({
                            id: "",
                            unit: { id: data.id, name: data.name },
                            grade: { gradeId: data.lesson.grade_id.id, gradeName: data.lesson.grade_id.name },
                            deletedOption: [],
                            deleteS3Path: [],
                            status: String(data.isActive),
                            question: "",
                            challengeMedia: {
                                audioFile: { files: "", blobPath: "", fileExtension: "" },
                                rhymeAudioFile: { files: "", blobPath: "", fileExtension: "" },
                            },
                            hint: { id: "", files: null, blobPath: "", removeFiles: "" },
                            karaokeVideo: { id: "", files: "", blobPath: "", removeFiles: "" },
                            checkTheRhyme: {
                                RhymeText: "",
                                Options: [{ id: "", media: { audio: { files: "", blobPath: "", fileExtension: "" } }, optionText: "", isAnswer: false }],
                                MediaFile: {
                                    cardImageFile: { files: "", blobPath: "", fileExtension: "" }
                                },
                                flipRhymeText: "",
                                hintText: "",
                                reward: 0
                            },
                            congratulation: {
                                congratulationId: "",
                                // congratulationBadgeIcon: {
                                //     files: "",
                                //     blobPath: "",
                                //     fileExtension: ""

                                // },
                                congratulationAudio: {
                                    files: "",
                                    blobPath: "",
                                    fileExtension: ""

                                },
                                congratulationText: "",
                                congratulationCoins: 0,
                                deletedS3Path: []
                            }
                        })

                        await getKaraokeVideo({ unit_id: data.id, grade_id: data.lesson.grade_id.id }, access_token).then((listResponse) => {
                            if (listResponse.length > 0) {
                                setShowKaraokeVideoInputField(false);
                            } else {
                                setShowKaraokeVideoInputField(true);
                            }
                        })
                        await checkCongratulationData({ difficulty_level_Id: 4, unit_id: data.id, challenge_type: "RHYME" }, access_token).then((checkCongratsResponse) => {
                            const { data, statusCode } = checkCongratsResponse;
                            if (statusCode === 200) {
                                if (data) {
                                    setShowCongratulationsField(false)
                                } else {
                                    setShowCongratulationsField(true)
                                }
                            }

                        })
                        setDropdownList({
                            ...dropdownList,
                            dropdownLevel: data.level
                        })
                    }
                })
            } catch (error: any) {
                if (error.response && error.response.data && typeof error.response.data === "string") {
                    setMessage({
                        ...message,
                        failureMessage: error.response.data.message
                    })
                } else {
                    setMessage({
                        ...message,
                        failureMessage: "Something went wrong. Please try again"
                    })
                }

            } finally {
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            }
        }
    }


    const handleCTRMedia = (e: any, label: string, optionIndex: number) => {
        if (label === "add") {
            const { name, files } = e.target;

            if (!files || files.length === 0) return;

            const file = files[0];

            if (name === "audioFile") {
                if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
                    if (checkFileLimit(file)) {
                        setEditCheckTheRhymeChallengeData((prevData) => {
                            const updatedOptions = [...prevData.checkTheRhyme.Options];
                            if (updatedOptions[optionIndex]) {
                                updatedOptions[optionIndex] = {
                                    ...updatedOptions[optionIndex],
                                    media: {
                                        ...updatedOptions[optionIndex].media,
                                        audio: {
                                            files: file,
                                            blobPath: URL.createObjectURL(file),
                                            fileExtension: file.name.toLowerCase().split(".").pop() || "",

                                        }
                                    },
                                };
                            }
                            return {
                                ...prevData,
                                checkTheRhyme: {
                                    ...prevData.checkTheRhyme,
                                    Options: updatedOptions,
                                }
                            };
                        });

                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }


                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported audio format. Please upload MP3, or WAV']
                    })
                    return;
                }
            }
        } else if (label === "delete") {
            setShow(true)
            setConfirmationPopupData({
                title: `Are you sure you want to delete?`,
                message: "This action cannot be undone.",
                descriptions: "",
                acceptText: "Delete",
                cancelText: "Cancel",
                onAccept: async () => {
                    setShow(false)

                    setEditCheckTheRhymeChallengeData((prevData) => {
                        const updatedOptions = [...prevData.checkTheRhyme.Options];
                        if (updatedOptions[optionIndex]) {
                            updatedOptions[optionIndex] = {
                                ...updatedOptions[optionIndex],
                                media: {
                                    ...updatedOptions[optionIndex].media,
                                    audio: {
                                        files: "",
                                        blobPath: "",
                                        fileExtension: "",

                                    }
                                },
                            };
                        }
                        return {
                            ...prevData,
                            checkTheRhyme: {
                                ...prevData.checkTheRhyme,
                                Options: updatedOptions,
                            }
                        };
                    });
                },
                onCancel: handleClose,
            })


        }

    }

    const handleInputChange = (value: string, OptionIndex: number, label: string) => {
        if (label === "delete") {
            setShow(true)
            setConfirmationPopupData({
                title: `Are you sure you want to delete?`,
                message: "This action cannot be undone.",
                descriptions: "",
                acceptText: "Delete",
                cancelText: "Cancel",
                onAccept: async () => {
                    setShow(false)

                    setEditCheckTheRhymeChallengeData((prevData: any) => {
                        const updatedData: CheckTheRhymeDataType = { ...prevData };

                        // Ensure `deletedOption` exists
                        if (!updatedData.deletedOption) {
                            updatedData.deletedOption = [];
                        }

                        // Check if `options` exists and `OptionIndex` is valid before accessing it
                        if (updatedData.checkTheRhyme && updatedData.checkTheRhyme.Options[OptionIndex] && updatedData.checkTheRhyme.Options[OptionIndex].id) {
                            updatedData.deletedOption = [
                                ...updatedData.deletedOption,
                                updatedData.checkTheRhyme.Options[OptionIndex].id
                            ];
                        }

                        // Filter out the option at `OptionIndex`
                        if (updatedData.checkTheRhyme.Options) {
                            updatedData.checkTheRhyme.Options = updatedData.checkTheRhyme.Options.filter((_, index) => index !== OptionIndex);
                        }

                        return updatedData;
                    });



                },
                onCancel: handleClose,
            })
        } else if (label === "add") {
            setEditCheckTheRhymeChallengeData((prevData: any) => {
                let updatedData: CheckTheRhymeDataType = { ...prevData };
                let errorList: string[] = [];

                // Ensure options is initialized properly
                const options = updatedData.checkTheRhyme.Options ?? [];

                // Validate that no optionText is empty
                const hasEmptyOption = options.some(option => option.optionText.trim() === "");
                const mediaFile = options.some(option => !option.media.audio.files)
                if (hasEmptyOption) {
                    errorList.push("Please input valid text for all options.");
                }
                if (mediaFile) {
                    errorList.push("Please upload valid VO for all options.");
                }

                if (errorList.length === 0) {
                    updatedData.checkTheRhyme.Options = [
                        ...options,
                        { id: "", media: { audio: { files: "", blobPath: "", fileExtension: "" } }, optionText: "", isAnswer: false }
                    ];
                } else {
                    setMessage({
                        ...message,
                        errorMessage: errorList
                    });
                }


                return updatedData;
            });
        } else if (label === "question") {
            setEditCheckTheRhymeChallengeData((prevData: any) => {
                const updatedData: CheckTheRhymeDataType = { ...prevData };
                updatedData.question = value;
                updatedData.checkTheRhyme.RhymeText = value;

                return { ...updatedData };
            })
        } else if (label === "flipText") {
            setEditCheckTheRhymeChallengeData((prevData: any) => {
                const updatedData: CheckTheRhymeDataType = { ...prevData };
                updatedData.checkTheRhyme.flipRhymeText = removeSpans(value);

                return { ...updatedData };
            })
        } else if (label === "hintText") {
            setEditCheckTheRhymeChallengeData((prevData: any) => {
                const updatedData: CheckTheRhymeDataType = { ...prevData };
                updatedData.checkTheRhyme.hintText = removeSpans(value);

                return { ...updatedData };
            })
        } else if (label === "reward") {
            setEditCheckTheRhymeChallengeData((prevData: any) => {
                const updatedData: CheckTheRhymeDataType = { ...prevData };
                updatedData.checkTheRhyme.reward = Number(value);

                return { ...updatedData };
            })
        }
        else {

            if (label === "option") {
                setEditCheckTheRhymeChallengeData((prevData: any) => {
                    const updatedData: CheckTheRhymeDataType = { ...prevData };


                    updatedData.checkTheRhyme.Options = updatedData.checkTheRhyme.Options.map((option: any, index: number) =>
                        index === OptionIndex ? { ...option, optionText: value, IsAnswer: option.IsAnswer } : option
                    ) || []


                    return { ...updatedData };
                });
            } else if (label === "answer") {
                setEditCheckTheRhymeChallengeData((prevData: any) => {
                    const updatedData: CheckTheRhymeDataType = { ...prevData };
                    let errorList: string[] = [];

                    updatedData.checkTheRhyme.Options = updatedData.checkTheRhyme.Options.map((option: OptionDataType, index: number) => {
                        // Check if the option is the target option and optionText is empty
                        if (index === OptionIndex && !option.optionText.trim()) {
                            errorList.push("Option text cannot be empty.");
                            setMessage({
                                ...message,
                                errorMessage: errorList
                            });
                            return option;
                        }

                        // Reset isAnswer for all options
                        option.isAnswer = false;

                        // If this is the correct option, update optionText and set isAnswer to true
                        if (index === OptionIndex) {
                            return { ...option, isAnswer: true };
                        }

                        return option;
                    }) || [];

                    return { ...updatedData };
                });
            }



        }
    }


    const validateKaraokeData = () => {
        let errorMessage: string[] = [];
        const isMediaValid = (media: any) => media && media.files;

        if (!isMediaValid(editCheckTheRhymeChallengeData.karaokeVideo)) errorMessage.push("Please upload a valid Karaoke video");
        if (errorMessage.length > 0) {
            setMessage({
                ...message,
                errorMessage: errorMessage,
            });
            return false;
        } else {
            handleSubmitKaraokeData();
        }
    }

    const handleSubmitKaraokeData = async () => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, viewLoading: false, validationLoading: false }));

        try {
            const { grade, unit } = editCheckTheRhymeChallengeData;

            const KaraokeFormData = new FormData();
            KaraokeFormData.append("grade_id", grade.gradeId);
            KaraokeFormData.append("unit_id", unit.id);

            // ✅ Always append video_path only if it's a real File
            if (editCheckTheRhymeChallengeData.karaokeVideo.files instanceof File) {
                KaraokeFormData.append("video_path", editCheckTheRhymeChallengeData.karaokeVideo.files);
            }

            // ✅ Always append animation_path only if it's a real File
            if (editCheckTheRhymeChallengeData.hint.files instanceof File) {
                KaraokeFormData.append("hint_animation", editCheckTheRhymeChallengeData.hint.files);
            }

            if (editCheckTheRhymeChallengeData.karaokeVideo.id) {
                let removeFilesArray = [];
                if (editCheckTheRhymeChallengeData.karaokeVideo.removeFiles && editCheckTheRhymeChallengeData.karaokeVideo.removeFiles.trim()) {
                    removeFilesArray.push(editCheckTheRhymeChallengeData.karaokeVideo.removeFiles.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, ""));
                }
                if (editCheckTheRhymeChallengeData.hint.removeFiles && editCheckTheRhymeChallengeData.karaokeVideo.removeFiles.trim()) {
                    removeFilesArray.push(editCheckTheRhymeChallengeData.hint.removeFiles.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, ""))

                }

                if (removeFilesArray.length > 0) {
                    KaraokeFormData.append('removeFiles', JSON.stringify(removeFilesArray.map((path: string) => ({ path: path }))));
                }


                // update case
                const updateResponse = await updateKaraokeVideo(editCheckTheRhymeChallengeData.karaokeVideo.id, KaraokeFormData, access_token);

                if (updateResponse.statusCode === 200) {
                    setMessage({
                        ...message,
                        successMessage: updateResponse.message,
                    });
                    setEditCheckTheRhymeChallengeData(prev => ({
                        ...prev,
                        karaokeVideo: {
                            ...prev.karaokeVideo,
                            id: updateResponse.data[0].id,
                            files: updateResponse.data[0].video_path,
                            blobPath: updateResponse.data[0].video_path,
                            removeFiles: "",
                        },
                        hint: {
                            ...prev.hint,
                            id: updateResponse.data[0].id,
                            files: updateResponse.data[0].hint_animation,
                            blobPath: updateResponse.data[0].hint_animation,
                            removeFiles: "",
                        }
                    }));
                }
            } else {
                // create case
                const createResponse = await createKaraokeVideo(KaraokeFormData, access_token);

                if (createResponse.statusCode === 200) {
                    setMessage({
                        ...message,
                        successMessage: "Karaoke Video created successfully!",
                    });
                    setEditCheckTheRhymeChallengeData(prev => ({
                        ...prev,
                        karaokeVideo: {
                            ...prev.karaokeVideo,
                            id: createResponse.data.id,
                            files: createResponse.data.video_path, // file path string
                            blobPath: `${createResponse.data.video_path}`,

                        }
                    }));
                }
            }


        } catch (error: any) {
            setMessage({
                ...message,
                failureMessage:
                    error.response?.data?.message?.[0] ||
                    "Something went wrong. Please try again",
            });
        } finally {
            setTimeout(() => {
                setMessage((prev: MessageDataType) => ({
                    ...prev,
                    failureMessage: "",
                    successMessage: "",
                }));
            }, 2500);
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    };



    const handleChallengeMedia = (e: any, label: string, fieldName?: string) => {
        const { name, files } = e.target;

        if (label === "delete") {
            setShow(true)
            setConfirmationPopupData({
                title: `Are you sure you want to delete?`,
                message: "This action cannot be undone.",
                descriptions: "",
                acceptText: "Delete",
                cancelText: "Cancel",
                onAccept: async () => {
                    setShow(false)
                    setEditCheckTheRhymeChallengeData((prev: any) => {
                        const updatedData: CheckTheRhymeDataType = { ...prev }

                        if (fieldName === "cardImageFile") {
                            setEditCheckTheRhymeChallengeData((prev) => ({
                                ...prev,
                                checkTheRhyme: {
                                    ...editCheckTheRhymeChallengeData.checkTheRhyme,
                                    MediaFile: {
                                        ...editCheckTheRhymeChallengeData.checkTheRhyme.MediaFile,
                                        cardImageFile: { files: "", blobPath: "", fileExtension: "" },
                                    }
                                }
                            }))
                        } else if (fieldName === `audioFile`) {
                            setEditCheckTheRhymeChallengeData((prev) => ({
                                ...prev,
                                challengeMedia: {
                                    ...editCheckTheRhymeChallengeData.challengeMedia,
                                    audioFile: { files: "", blobPath: "", fileExtension: "" },
                                }
                            }))
                        } else if (fieldName === "rhymeAudioFile") {
                            setEditCheckTheRhymeChallengeData((prev) => ({
                                ...prev,
                                challengeMedia: {
                                    ...editCheckTheRhymeChallengeData.challengeMedia,
                                    rhymeAudioFile: { files: "", blobPath: "", fileExtension: "" },
                                }
                            }))
                        } else if (fieldName === "karaokeVideo") {
                            setEditCheckTheRhymeChallengeData(prev => ({
                                ...prev,
                                karaokeVideo: {
                                    ...prev.karaokeVideo,
                                    removeFiles: prev.karaokeVideo.files instanceof File ? "" : prev.karaokeVideo.files,
                                    files: null,
                                    blobPath: ""
                                }

                            }))
                        } else if (fieldName === "hintAnimation") {
                            setEditCheckTheRhymeChallengeData(prev => ({
                                ...prev,
                                hint: {
                                    ...prev.hint,
                                    removeFiles: prev.karaokeVideo.files instanceof File ? "" : prev.karaokeVideo.files,
                                    files: null,
                                    blobPath: ""
                                }

                            }))
                        }
                        return updatedData;
                    })
                },
                onCancel: handleClose,
            })
        } else if (label === "add") {


            if (name === 'audioFile') {

                const file = files?.[0];


                if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
                    if (checkFileLimit(file)) {
                        setEditCheckTheRhymeChallengeData((prev) => ({
                            ...prev,
                            challengeMedia: {
                                ...editCheckTheRhymeChallengeData.challengeMedia,
                                audioFile: {
                                    files: file,
                                    blobPath: file ? URL.createObjectURL(file) : undefined,
                                    fileExtension: file?.name.split('.').pop()?.toLowerCase() || '',
                                },
                            },
                        }));

                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }

                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported audio format. Please upload MP3, or WAV']
                    });
                    return;
                }


            } else if (name === "rhymeAudioFile") {
                const file = files?.[0];

                if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
                    if (checkFileLimit(file)) {
                        setEditCheckTheRhymeChallengeData((prev) => ({
                            ...prev,
                            challengeMedia: {
                                ...editCheckTheRhymeChallengeData.challengeMedia,
                                rhymeAudioFile: {
                                    files: file,
                                    blobPath: file ? URL.createObjectURL(file) : undefined,
                                    fileExtension: file?.name.split('.').pop()?.toLowerCase() || '',
                                },
                            },
                        }));

                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }

                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported audio format. Please upload MP3, or WAV']
                    });
                    return;
                }
            } else if (name === 'cardImageFile') {
                const file = files?.[0];

                if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg'))) {
                    if (checkFileLimit(file)) {
                        setEditCheckTheRhymeChallengeData((prev) => ({
                            ...prev,
                            checkTheRhyme: {
                                ...editCheckTheRhymeChallengeData.checkTheRhyme,
                                MediaFile: {
                                    ...editCheckTheRhymeChallengeData.checkTheRhyme.MediaFile,
                                    cardImageFile: {
                                        files: file,
                                        blobPath: file ? URL.createObjectURL(file) : undefined,
                                        fileExtension: file?.name.split('.').pop()?.toLowerCase() || '',
                                    },
                                },
                            },
                        }));

                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }

                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported image format. Please upload JPG, PNG, or JPEG files.']
                    });
                    return;
                }


            } else if (name === "karaokeVideo") {
                const file = files?.[0];
                if (file && (file.name.toLowerCase().endsWith('.mp4') || file.name.toLowerCase().endsWith('.webm'))) {
                    if (checkFileLimit(file)) {
                        setEditCheckTheRhymeChallengeData(prev => ({
                            ...prev,
                            karaokeVideo: {
                                ...prev.karaokeVideo,
                                files: file,
                                blobPath: URL.createObjectURL(file)
                            }
                        }))

                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }

                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported video format. Please upload MP4, or WEBP']
                    });
                    return;
                }
            } else if (name === "hintAnimation") {
                const file = files?.[0];
                if (file && file.name.toLowerCase().endsWith('.json')) {
                    if (checkFileLimit(file)) {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            try {
                                const json = JSON.parse(event.target?.result as string);
                                if (!isLottieJson(json)) {
                                    setMessage({
                                        ...message,
                                        errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                                    })
                                    return;
                                }

                                // Proceed to set state if valid
                                setEditCheckTheRhymeChallengeData(prev => ({
                                    ...prev,
                                    hint: {
                                        ...prev.karaokeVideo,
                                        files: file,
                                        blobPath: URL.createObjectURL(file)
                                    }
                                }))
                            } catch (err) {
                                setMessage({
                                    ...message,
                                    errorMessage: ['Failed to parse JSON file.']
                                })
                            }
                        };
                        reader.readAsText(file);
                        return;
                    } else {
                        setMessage({
                            ...message,
                            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
                        });
                        return;
                    }

                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported JSON format. Please upload Lottiee JSON.']
                    })
                    return;
                }
            }


        }
    }


    const viewAllQuestion = useCallback(async (unitId: string) => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        try {
            setViewAllChallenges(true);
            setFilter({
                status: "",
                dateFilter: "",
                grade: ""
            })
            setActiveFilter({
                status: "",
                grade: { id: "", name: "" }
            })
            setStartDate(null)
            setEndDate(null);
            setSearchText("");
            try {
                await getUnitByUnitId(unitId, access_token).then(async (getUnitResponse) => {
                    const { data, statusCode } = getUnitResponse;
                    if (statusCode === 200) {
                        setEditCheckTheRhymeChallengeData({
                            id: "",
                            unit: { id: data.id, name: data.name },
                            grade: { gradeId: data.lesson.grade_id.id, gradeName: data.lesson.grade_id.name },
                            status: String(data.isActive),
                            deletedOption: [],
                            deleteS3Path: [],
                            question: "",
                            challengeMedia: {
                                audioFile: { files: "", blobPath: "", fileExtension: "" },
                                rhymeAudioFile: { files: "", blobPath: "", fileExtension: "" },
                            },
                            hint: { id: "", files: null, blobPath: "", removeFiles: "" },
                            karaokeVideo: { id: "", files: null, blobPath: "", removeFiles: "" },
                            checkTheRhyme: {
                                RhymeText: "",
                                Options: [{ id: "", media: { audio: { files: "", blobPath: "", fileExtension: "" } }, optionText: "", isAnswer: false }],
                                MediaFile: {
                                    cardImageFile: { files: "", blobPath: "", fileExtension: "" }
                                },
                                flipRhymeText: "",
                                hintText: "",
                                reward: 0
                            },
                            congratulation: {
                                congratulationId: "",
                                congratulationBadgeIcon: {
                                    files: "",
                                    blobPath: "",
                                    fileExtension: ""

                                },
                                congratulationAudio: {
                                    files: "",
                                    blobPath: "",
                                    fileExtension: ""

                                },
                                congratulationText: "",
                                congratulationCoins: 0,
                                deletedS3Path: []
                            }
                        })

                        const challengeResponse = await GetAllChallenges(data.id, data.lesson.grade_id.id, QuestionCategory.rhyme, '0', String(itemsPerPage), access_token);
                        if (challengeResponse.statusCode === 200) {
                            handleChallengeData(challengeResponse.data)
                        } else if (statusCode === 401) {
                            getAuthorizedToken();
                            setMessage((prevMessage: MessageDataType) => ({
                                ...prevMessage,
                                failureMessage: 'Authorization token expired. Try again!',
                            }));
                        }
                    }

                })

            } catch (error: any) {
                if (error.response && error.response.data && typeof error.response.data === "string") {
                    setMessage({
                        ...message,
                        failureMessage: error.response.data.message
                    })
                } else {
                    setMessage({
                        ...message,
                        failureMessage: "Something went wrong. Please try again"
                    })
                }
            }
        } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                })
            } else {
                setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                })
            }
        } finally {
            setTimeout(() => {
                setMessage(((prev: MessageDataType) => {
                    const updatedData = { ...prev };
                    updatedData.errorMessage = prev.errorMessage;
                    updatedData.failureMessage = "";
                    updatedData.successMessage = ""
                    return updatedData
                }))

            }, 2500)
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }

    }, [])

    const handleDeleteChallenge = useCallback(async (unitName: string, unitId: string) => {
        setShow(true)
        setConfirmationPopupData({
            title: `Are you sure you want to delete challenges?`,
            message: "This action cannot be undone.",
            descriptions: "",
            acceptText: "Yes",
            cancelText: "Cancel",
            onAccept: async () => {
                setShow(false);
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, viewLoading: false, validationLoading: false }));
                try {
                    await DeletAllChallengesByUnitId(unitId, "RHYME", access_token).then((getUnitResponse) => {
                        const { data, statusCode } = getUnitResponse;
                        if (statusCode === 200) {
                            setMessage({
                                ...message,
                                successMessage: "All challenges deleted successfully!"
                            })
                        }

                    }).catch((error: any) => {
                        console.error("Error fetching tribe data:", error);
                        if (error.response && error.response.data && typeof error.response.data === "string") {
                            setMessage({
                                ...message,
                                failureMessage: error.response.data.message,
                            });
                        } else {
                            setMessage({
                                ...message,
                                failureMessage: "Something went wrong. Please try again",
                            });
                        }
                    })
                } catch (error: any) {
                    console.error('Get All Challenges Error:', error);
                    if (error.response && error.response.data && typeof error.response.data === "string") {
                        setMessage({
                            ...message,
                            failureMessage: error.response.data.message,
                        });
                    } else {
                        setMessage({
                            ...message,
                            failureMessage: "Something went wrong. Please try again",
                        });
                    }
                } finally {
                    setTimeout(() => {
                        setMessage({
                            errorMessage: [],
                            successMessage: "",
                            failureMessage: ""
                        })
                    }, 2500)
                    setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                    setCurrentPage(1);
                    getAllChallenges(indexOfFirstItem);
                }


            },
            onCancel: handleClose,
        })


    }, [])

    const handlePreview = (tableCTRData: TableChallengeDataType ) => {
        // Open the child window — must be triggered by a direct user interaction
        const win = window.open(process.env.REACT_APP_REDIRECT_WINDOW, "_blank");

        if (!win) {
            alert("Popup blocked! Please allow popups for this site.");
            return;
        }

        // Add the message listener immediately
        const handleMessage = (event: MessageEvent) => {
            if (event.origin === process.env.REACT_APP_REDIRECT_WINDOW) {
                window.removeEventListener("message", handleMessage); // Clean up
            } else {
                console.warn("Message blocked from unknown origin:", event.origin);
            }
        };

        window.addEventListener("message", handleMessage);

        // Function to send message when the child window is ready
        const sendMessage = () => {
            try {
                if (win && typeof process.env.REACT_APP_REDIRECT_WINDOW === 'string') {
                    win.postMessage({ accessToken: access_token, refreshToken: refresh_token, lessonId: tableCTRData.lesson.id, unitId: tableCTRData.unit.id, gradeId: tableCTRData.grade.gradeId, category: "4", challengeType: "CTR" }, process.env.REACT_APP_REDIRECT_WINDOW);
                } else {
                    console.error("Invalid window reference or redirect window URL is not set");
                }

            } catch (error) {
                console.error("Error sending message:", error);
            }
        };

        // Try sending the message a few times to ensure it reaches
        let tries = 0;
        const interval = setInterval(() => {
            if (win.closed) {
                clearInterval(interval);
                return;
            }

            sendMessage();
            tries++;

            if (tries >= 3) {
                clearInterval(interval);
            }
        }, 1000);
    }


    return (
        <div className="dashboard d-flex">
            <Header />
            <div className="rightContainer">
                <div>
                    {message.successMessage && <SuccessPopup message={message.successMessage} />}

                    {message.failureMessage && <FailurePopup message={message.failureMessage} />}
                    {addChallenges ?
                        <div>
                            <h2 className="main-title text-center page-title">Add Check The Rhyme</h2>
                            <div className="pCard" style={{ backgroundColor: "#ffffff" }}>
                                <Form noValidate validated={validated}>
                                    <div className="modal-body" style={{ textAlign: "start" }}>
                                        <div className="d-flex flex-column">
                                            <div>
                                                {!viewAllChallenges && <div className="form-group">
                                                    <h6 className='highlightMediaText'>Unit <span className="text-danger">*</span></h6>
                                                    <select className="form-select" name="challengeUnit" value={editCheckTheRhymeChallengeData.unit.id} onChange={(e) => handleDropDownData(e.target.name, e.target.value)} required >
                                                        <option value="" disabled>
                                                            Select Unit
                                                        </option>
                                                        {dropdownList.dropdownUnit.length > 0 ? (
                                                            dropdownList.dropdownUnit.map((option: IdAndName) => (
                                                                <option key={option.id} value={option.id}>
                                                                    {option.name}
                                                                </option>
                                                            ))
                                                        ) : (
                                                            <option value="" disabled>
                                                                No Unit added yet
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>}

                                                {!viewAllChallenges && showKaraokeVideoInputField && editCheckTheRhymeChallengeData.unit.id && <React.Fragment>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5 className='text-center my-3 border-bottom pb-1'>Karaoke Video and Hint Lottiee JSON Animation</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <h6 className='highlightMediaText'>Karaoke Video <span className="text-danger">*</span></h6>
                                                                <div className="customImgUpload">
                                                                    <div className="uploadBtn">
                                                                        {editCheckTheRhymeChallengeData.karaokeVideo.files ?
                                                                            <div className="w-100">
                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                    <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                                                        <source src={editCheckTheRhymeChallengeData.karaokeVideo.blobPath} type="video/mp4" />
                                                                                        Your browser does not support the video tag.
                                                                                    </video>
                                                                                </div>
                                                                                {editCheckTheRhymeChallengeData.karaokeVideo.files instanceof File &&
                                                                                    <div className="imgName">
                                                                                        {editCheckTheRhymeChallengeData.karaokeVideo.files.name}
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <>
                                                                                <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                <label htmlFor="karaokeVideo">Click to upload <span>mp4 or webm <br />(max 250mb)</span></label>
                                                                                <input type="file" className="form-control d-none" id="karaokeVideo" name="karaokeVideo" accept=".mp4, .webm" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {editCheckTheRhymeChallengeData.karaokeVideo.files && <div className="row justify-content-center">
                                                                <div className="col-auto">
                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "karaokeVideo")}>
                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                    </button>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <h6 className='highlightMediaText'>Hint Animation <span className="text-danger">*</span></h6>
                                                                <div className="customImgUpload">
                                                                    <div className="uploadBtn">
                                                                        {editCheckTheRhymeChallengeData.hint.files ?
                                                                            <div className="w-100">
                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                    <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                                        {/* <LottieAnimation animationPath={editCheckTheRhymeChallengeData.hint.blobPath} style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh", margin: "0 auto" }} /> */}
                                                                                        <div className="imgName" onClick={() => handleOpenMedia(editCheckTheRhymeChallengeData.hint.files)}>
                                                                                            {editCheckTheRhymeChallengeData.hint.files instanceof File
                                                                                                ? editCheckTheRhymeChallengeData.hint.files.name
                                                                                                : `${editCheckTheRhymeChallengeData.grade.gradeName} CTR Hint`
                                                                                            }
                                                                                        </div>
                                                                                        {/* <p onClick={() => handleOpenMedia(editCheckTheRhymeChallengeData.hint.files)}>{editCheckTheRhymeChallengeData.grade.gradeName} CTR Hint</p> */}
                                                                                    </div>
                                                                                </div>

                                                                                {/* {editCheckTheRhymeChallengeData.hint.files instanceof File &&
                                                                                    <div className="imgName">
                                                                                        {editCheckTheRhymeChallengeData.hint.files.name}
                                                                                    </div>
                                                                                } */}
                                                                            </div>
                                                                            :
                                                                            <>
                                                                                <img className="noimage" src="./assets/images/no-image-icon.png" alt="no-image-icon" />
                                                                                <label htmlFor="hintAnimation">Click to upload <span>json <br />(max 20mb)</span></label>
                                                                                <input type="file" className="form-control d-none" id="hintAnimation" name="hintAnimation" accept=".json" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {editCheckTheRhymeChallengeData.hint.files && <div className="row justify-content-center">
                                                                <div className="col-auto">
                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "hintAnimation")}>
                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                    </button>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>


                                                </React.Fragment>}

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <h5 className='text-center my-3 border-bottom pb-1'>Question</h5>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Add Rhyme Challenge <span className="text-danger">*</span></h6>
                                                            <textarea name="question" rows={6} placeholder="Add Rhyme Challenge" value={editCheckTheRhymeChallengeData.checkTheRhyme.RhymeText} onChange={(e) => handleInputChange(e.target.value, -1, "question")} required />
                                                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid question.</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Rhyme Challenge VO <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload">
                                                                <div className="uploadBtn">
                                                                    {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files ?
                                                                        <div className="w-100">
                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                <audio src={editCheckTheRhymeChallengeData.challengeMedia.audioFile.blobPath} className="mx-auto" controls />
                                                                                {/* <button type="button" className="bg-transparent" onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")} >
                                                                                    <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                </button> */}

                                                                            </div>
                                                                            {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files !== editCheckTheRhymeChallengeData.challengeMedia.audioFile.blobPath &&
                                                                                <div className="imgName">
                                                                                    {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files.name}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <>
                                                                            <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                            <label htmlFor="audioFile">Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                            <input type="file" className="form-control d-none" id="audioFile" name="audioFile" accept=".mp3, .wav" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files && <div className="row justify-content-center">
                                                            <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")}>
                                                                    <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                            </div>
                                                        </div>}
                                                    </div>
                                                </div>


                                                <div className="form-group">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h6 className='highlightMediaText'>Options (select the checkbox if corresponding option is the answer) <span className="text-danger">*</span></h6>
                                                            {editCheckTheRhymeChallengeData.checkTheRhyme.Options.map((option: OptionDataType, optionIndex: number) => (
                                                                <div className="form-group" key={`option-${optionIndex}`} >
                                                                    <div className="row">
                                                                        <div className="col-md-4 my-auto">
                                                                            <h6 className='highlightMediaText'>Option {optionIndex + 1} <span className="text-danger">*</span></h6>

                                                                            <input className="form-control w-100" type="text" id={`option-${optionIndex}`} value={option.optionText || ""} name={`option-${optionIndex}`} placeholder={`Option ${optionIndex + 1}`} onChange={(e) => handleInputChange(e.target.value, optionIndex, "option")} required />
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <h6 className='highlightMediaText'>Option {optionIndex + 1} VO <span className="text-danger">*</span></h6>

                                                                            <div className="customImgUpload">
                                                                                <div className="uploadBtn">
                                                                                    {option.media.audio.files ?
                                                                                        <div className="w-100">
                                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                <audio src={option.media.audio.blobPath} className="mx-auto" controls />
                                                                                            </div>
                                                                                            {option.media.audio.files !== option.media.audio.blobPath &&
                                                                                                <div className="imgName">
                                                                                                    {option.media.audio.files.name}
                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                        :
                                                                                        <>
                                                                                            <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                            <label htmlFor={`audioFile${optionIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                                            <input type="file" className="form-control d-none" id={`audioFile${optionIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleCTRMedia(e, "add", optionIndex)} required />
                                                                                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a voice over audio.</div>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            {option.media.audio.files && <div className="row justify-content-center">
                                                                                <div className="col-auto">
                                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }}
                                                                                        onClick={() => handleCTRMedia(null, "delete", optionIndex)}  >
                                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                                    </button>
                                                                                </div>
                                                                            </div>}
                                                                        </div>
                                                                        <div className='col-auto my-auto'>
                                                                            <div className="d-flex justify-content-between h-100">
                                                                                <input type="checkbox" className="ms-3 m-2" style={{ transform: "scale(1.5)" }} checked={option.isAnswer || false} onChange={(e) => handleInputChange(e.target.value, optionIndex, "answer")} />
                                                                                {editCheckTheRhymeChallengeData.checkTheRhyme.Options.length > 1 && (
                                                                                    <button className="btn" type="button" onClick={() => handleInputChange("", optionIndex, "delete")}>
                                                                                        <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                    </button>
                                                                                )}
                                                                                {editCheckTheRhymeChallengeData.checkTheRhyme.Options.length - 1 === optionIndex && (
                                                                                    <button className="btn" type="button" onClick={() => handleInputChange("", optionIndex, "add")}>
                                                                                        <img src="./assets/images/add-icon.svg" alt="add" />
                                                                                    </button>
                                                                                )}

                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Hint Text <span className="text-danger">*</span></h6>
                                                            <textarea name="hintText" rows={4} placeholder="Hint" value={editCheckTheRhymeChallengeData.checkTheRhyme.hintText} onChange={(e) => handleInputChange(e.target.value, -1, "hintText")} required />

                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Flip Rhyme Text <span className="text-danger">*</span></h6>
                                                            <ReactQuill
                                                                className="whitebg"
                                                                id="flipText"
                                                                value={editCheckTheRhymeChallengeData.checkTheRhyme.flipRhymeText}
                                                                onChange={(value) => handleInputChange(value, -1, "flipText")}
                                                                style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                                                modules={{
                                                                    toolbar: [
                                                                        [{ header: [3, 4, false] }],
                                                                        ["bold", "italic", "underline", "blockquote"],
                                                                        [
                                                                            { list: "ordered" },
                                                                            { list: "bullet" },
                                                                            { indent: "-1" },
                                                                            { indent: "+1" }
                                                                        ],
                                                                        [{ align: [] }],
                                                                        ["clean"]
                                                                    ]
                                                                }}
                                                                formats={[
                                                                    "bold", "italic", "underline", "blockquote",
                                                                    "list", "bullet", "indent", "align"
                                                                ]}
                                                            />

                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Flip Rhyme Text VO <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload">
                                                                <div className="uploadBtn">
                                                                    {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files ?
                                                                        <div className="w-100">
                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                <audio src={editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.blobPath} className="mx-auto" controls />
                                                                                {/* <button type="button" className="bg-transparent" onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")} >
                                                                                    <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                </button> */}

                                                                            </div>
                                                                            {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files !== editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.blobPath &&
                                                                                <div className="imgName">
                                                                                    {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files.name}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <>
                                                                            <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                            <label htmlFor="rhymeAudioFile">Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                            <input type="file" className="form-control d-none" id="rhymeAudioFile" name="rhymeAudioFile" accept=".mp3, .wav" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files && <div className="row justify-content-center">
                                                            <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "rhymeAudioFile")}>
                                                                    <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                            </div>
                                                        </div>}

                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Reward for the completion of this add the rhyme question <span className="text-danger">*</span></h6>
                                                            <input type='number' name="reward" className="form-control" placeholder="Hint" value={editCheckTheRhymeChallengeData.checkTheRhyme.reward} onChange={(e) => handleInputChange(e.target.value, -1, "reward")} onWheel={(e: any) => e.target.blur()} required />

                                                        </div>
                                                    </div>


                                                </div>

                                                {!viewAllChallenges && showCongratulationsField && editCheckTheRhymeChallengeData.unit.id &&

                                                    <React.Fragment>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <h5 className='text-center my-3 border-bottom pb-1'>Congratulations Screen</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row">

                                                            <div className="col-md-6">
                                                                <h6 className='highlightMediaText'>Congratulations Text <span className="text-danger">*</span></h6>
                                                                <ReactQuill className='whitebg' onChange={(value) => handleCongratsInput(null, "congratulation-text", value, false)} value={editCheckTheRhymeChallengeData?.congratulation?.congratulationText || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                                                    modules={{
                                                                        toolbar: [
                                                                            [{ header: [3, 4, false] }],
                                                                            ["bold", "italic", "underline", "blockquote"],
                                                                            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                                                            [{ align: [] }]
                                                                        ]
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="col-md-6">
                                                                <h6 className='highlightMediaText'>Congratulations Voice Over <span className="text-danger">*</span></h6>
                                                                {/* Audio Upload/Preview */}
                                                                <div className="customImgUpload mb-3">
                                                                    <div className="uploadBtn">
                                                                        {editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files ? (
                                                                            <div className="w-100">
                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                    <audio src={editCheckTheRhymeChallengeData.congratulation.congratulationAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                                </div>
                                                                                {editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files !== editCheckTheRhymeChallengeData.congratulation.congratulationAudio.blobPath && (
                                                                                    <div className="imgName">{editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files.name}</div>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                <label htmlFor="congratulations-audio">
                                                                                    Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                                                </label>
                                                                                <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Replace Audio */}
                                                                {editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files && (
                                                                    <div className="row justify-content-center">
                                                                        <div className="col-auto">
                                                                            <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                                                                <label className='m-0 flex' htmlFor="congratulations-audio" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                                                                    <img src="./assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                                                                    <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                                    Replace
                                                                                </label>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>



                                                        </div>
                                                    </React.Fragment>

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </Form>

                                <div className="form-actions">
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3"></div>

                                        <div className="col-md-3">
                                            <div className="btn-group w-100">
                                                <button type="button" className="btn btn-save btnPurple" onClick={checkTheRhymeValidation}>Save</button>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="header-container">

                                <h2 className="page-title text-center">Check The Rhyme</h2>

                                {viewAllChallenges && editCheckTheRhymeChallengeData.unit.name && <div className="breadcrumbBlock">
                                    <ul>
                                        <li>
                                            <a href='/check-the-rhyme'>Check The Rhyme</a> <img src="./assets/images/breadcrumb-arrow.svg" alt="" />
                                        </li>
                                        <li>
                                            {editCheckTheRhymeChallengeData.unit.name}
                                        </li>
                                        <li>

                                        </li>
                                    </ul>

                                </div>}
                            </div>
                            <div className="pCard">
                                <div className="topAction align-items-center">
                                    <div className="dropdown statusDrop">
                                        {!viewAllChallenges && <button className="dropdown-toggle" type="button" id="dropdownMenuButtonStatus" data-bs-toggle="dropdown" aria-expanded="false">
                                            {/* {activeFilter.status === "All" ? "Status" : activeFilter.status === "1" ? "Publish" : activeFilter.status === "0" ? "Inactive" : "Status"} */}
                                            Status
                                        </button>
                                        }
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonStatus">
                                            <li><button className={`dropdown-item`} name="status" onClick={() => handleFilter("status", "")}>All</button></li>
                                            <li><button className={`dropdown-item ${activeFilter.status === "1" ? "active" : ""}`} name="status" value="Published" onClick={() => handleFilter("status", "1")} >Published</button></li>
                                            <li><button className={`dropdown-item ${activeFilter.status === "2" ? "active" : ""}`} onClick={() => handleFilter("status", "2")}>Draft</button></li>
                                            <li><button className={`dropdown-item ${activeFilter.status === "0" ? "active" : ""}`} name="status" value="Unpublished" onClick={() => handleFilter("status", "0")} >Unpublished</button></li>
                                        </ul>

                                        {filter.status &&
                                            <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.status}
                                                <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("status", "")} /></span></span>
                                        }

                                        {!viewAllChallenges && <button className="dropdown-toggle" type="button" id="dropdownMenuButtonGrade" data-bs-toggle="dropdown" aria-expanded="false" style={{ paddingLeft: "2rem" }}>
                                            {/* {activeFilter.grade.id ? activeFilter.grade.name : "Grade"} */}
                                            Grade
                                        </button>}
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonGrade">
                                            <button className={`dropdown-item`} name="grade" value="showAllGrade" onClick={() => handleFilter("grade", { id: "", name: "" })} >
                                                All
                                            </button>
                                            {dropDownList.grade.map((grade: IdAndName, index: number) => (
                                                <li key={grade.id}>
                                                    <button className={`dropdown-item ${activeFilter.grade.id === grade.id ? "active" : ""}`} name="grade" value={grade.name} onClick={() => handleFilter("grade", { id: grade.id, name: grade.name })} >
                                                        {grade.name}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>



                                        {filter.grade &&
                                            <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.grade}
                                                <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("grade", { id: "", name: "" })} /></span></span>
                                        }


                                        {filter.dateFilter &&
                                            <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.dateFilter}
                                                <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("date", "")} /></span></span>
                                        }
                                    </div>

                                    <div className="dropdown filter ms-auto">
                                        {!viewAllChallenges && <a className="dropdown-toggle" href="#blank" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                                            <img src="./assets/images/filter.svg" alt="Filter" />
                                        </a>}
                                        <div className="dropdown-menu p-3" onClick={(e) => e.stopPropagation()}>
                                            <div className="mb-3">
                                                {/* <label htmlFor="startDate" className="form-label">
                                                    Start Date
                                                </label> */}
                                                <DatePicker id="startDate" selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" placeholderText="Date From" />
                                            </div>
                                            <div className="mb-3">
                                                {/* <label htmlFor="endDate" className="form-label">
                                                    End Date
                                                </label> */}
                                                <DatePicker id="endDate" selected={endDate} onChange={handleEndDateChange} className="form-control" placeholderText="Date To" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="searchInputDashboard">
                                        {!viewAllChallenges && <input type="text" placeholder="Search" name="searchText" value={searchtext} onChange={(e) => setSearchText(e.target.value)} />}
                                    </div>
                                    <button className="btn add-btn btnPurple w-auto px-3" onClick={handleAddCheckTheRhymeChallenge}>+</button>
                                </div>

                                {!viewAllChallenges ? (
                                    (loading.tableLoading) ? (
                                        <div className="d-flex align-items-center mt-5">
                                            <div className="loader mx-auto"></div>
                                        </div>
                                    ) : tableChallengeData.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>UNIT</th>
                                                        <th className="text-center">GRADE</th>
                                                        <th className="text-center">LESSON</th>
                                                        <th className="text-center">SUBJECT</th>
                                                        <th className="text-center">TRIBE</th>
                                                        <th className="text-center">STATUS</th>


                                                        <th className='text-center'>ACTION</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tableChallengeData.map((tableChallenge: TableChallengeDataType, index: number) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <span data-tooltip-id={`challenge-unit-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.unit.name} data-tooltip-place="top" >
                                                                    {tableChallenge.unit.name.length > 10 ? tableChallenge.unit.name.substring(0, 10) + "..." : tableChallenge.unit.name}
                                                                </span>
                                                                {tableChallenge.unit.name.length > 10 && <Tooltip id={`challenge-unit-tooltip-${tableChallenge.id}`} />}
                                                            </td>
                                                            <td className="text-center">{tableChallenge.grade.gradeId === "1" ? "Kinder" : tableChallenge.grade.gradeName}</td>
                                                            <td className="text-center">
                                                                <span data-tooltip-id={`challenge-lesson-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.lesson.name} data-tooltip-place="top" >
                                                                    {tableChallenge.lesson.name.length > 10 ? tableChallenge.lesson.name.substring(0, 10) + "..." : tableChallenge.lesson.name}
                                                                </span>
                                                                {tableChallenge.lesson.name.length > 10 && <Tooltip id={`challenge-lesson-tooltip-${tableChallenge.id}`} />}</td>
                                                            <td className="text-center">
                                                                <span data-tooltip-id={`challenge-subject-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.subject.name} data-tooltip-place="top" >
                                                                    {tableChallenge.subject.name.length > 10 ? tableChallenge.subject.name.substring(0, 10) + "..." : tableChallenge.subject.name}
                                                                </span>
                                                                {tableChallenge.subject.name.length > 10 && <Tooltip id={`challenge-subject-tooltip-${tableChallenge.id}`} />}
                                                            </td>
                                                            <td className="text-center">
                                                                <span data-tooltip-id={`challenge-tribe-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.tribe.name} data-tooltip-place="top" >
                                                                    {tableChallenge.tribe.name.length > 10 ? tableChallenge.tribe.name.substring(0, 10) + "..." : tableChallenge.tribe.name}
                                                                </span>
                                                                {tableChallenge.tribe.name.length > 10 && <Tooltip id={`challenge-tribe-tooltip-${tableChallenge.id}`} />}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={tableChallenge.status === "PUBLISHED" ? "activeStatus" : (tableChallenge.status === "DRAFT" ? "draftStatus" : "inactiveStatus")}>
                                                                    {tableChallenge.status}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="dropdown dots">
                                                                    <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><img src='./assets/images/more.svg' alt='action button' /></button>
                                                                    <ul className="dropdown-menu">
                                                                        {tableChallenge.status !== "UNPUBLISHED" && <li>
                                                                            <button className="dropdown-item" onClick={() => {setTableData(tableChallenge); handlePreview(tableChallenge)}}>
                                                                                <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                                                                Preview
                                                                            </button>
                                                                        </li>}
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => {setTableData(tableChallenge); viewAllQuestion(tableChallenge.id); }}>
                                                                                <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                                                                Edit
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleDeleteChallenge(tableChallenge.unit.name, tableChallenge.id)}>
                                                                                <img src="assets/images/delete.png" alt="" className="me-2" />
                                                                                Delete
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (!loading.tableLoading && <p className="text-center mt-5">No Data Found</p>
                                    )
                                ) :
                                <React.Fragment>

                                        {tableData.status !== "UNPUBLISHED" && <div className="p-3">
                                            <button className="btn add-btn btnPurple w-auto px-3" style={{ fontSize: "14px" }} onClick={() => handlePreview(tableData)}>Preview</button>
                                        </div>}

                                    <div className="accordionBox">
                                        <div className="accordion" id="accordionExample">

                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id={`headingFive`}>
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseFive`} aria-expanded="false" aria-controls={`collapseFive}`}>
                                                        Karaoke Video and Hint Lottiee JSON Animation
                                                    </button>
                                                </h2>
                                                <div id={`collapseFive`} className="accordion-collapse collapse" aria-labelledby={`headingFive}`} data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Karaoke Video <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload whitebg mb-3">
                                                                <div className="uploadBtn">
                                                                    {editCheckTheRhymeChallengeData.karaokeVideo.files ?
                                                                        <div className="w-100">
                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">

                                                                                <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                                                    <source src={`${editCheckTheRhymeChallengeData.karaokeVideo.blobPath}`} type="video/mp4" />
                                                                                    Your browser does not support the video tag.
                                                                                </video>


                                                                            </div>
                                                                            {editCheckTheRhymeChallengeData.karaokeVideo.files instanceof File &&
                                                                                <div className="imgName">
                                                                                    {editCheckTheRhymeChallengeData.karaokeVideo.files.name}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <>
                                                                            <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                            <label htmlFor="karaokeVideo">Click to upload <span>mp4 or webm <br />(max 250mb)</span></label>
                                                                            <input type="file" className="form-control d-none" id="karaokeVideo" name="karaokeVideo" accept=".mp4, .webm" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {editCheckTheRhymeChallengeData.karaokeVideo.files && <div className="row justify-content-center">
                                                            <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "karaokeVideo")}>
                                                                    <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                            </div>
                                                        </div>}

                                                        <div className="form-group">
                                                            <h6 className='highlightMediaText'>Hint Animation <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload whitebg mb-3">
                                                                <div className="uploadBtn">
                                                                    {editCheckTheRhymeChallengeData.hint.files ?
                                                                        <div className="w-100">
                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                                    {/* <LottieAnimation animationPath={editCheckTheRhymeChallengeData.hint.blobPath} style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh", margin: "0 auto" }} /> */}
                                                                                    <div className="imgName" onClick={() => handleOpenMedia(editCheckTheRhymeChallengeData.hint.files)}>
                                                                                        {editCheckTheRhymeChallengeData.hint.files instanceof File
                                                                                            ? editCheckTheRhymeChallengeData.hint.files.name
                                                                                            : `${editCheckTheRhymeChallengeData.grade.gradeName} CTR Hint`
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        <>
                                                                            <img className="noimage" src="./assets/images/no-image-icon.png" alt="no-image-icon" />
                                                                            <label htmlFor="hintAnimation">Click to upload <span>json <br />(max 20mb)</span></label>
                                                                            <input type="file" className="form-control d-none" id="hintAnimation" name="hintAnimation" accept=".json" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {editCheckTheRhymeChallengeData.hint.files && <div className="row justify-content-center">
                                                            <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "hintAnimation")}>
                                                                    <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                            </div>
                                                        </div>}

                                                        <div className="d-flex justify-content-end mt-3 mb-3">
                                                            <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateKaraokeData}>Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        Questions
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">

                                                        {loading.tableLoading ?
                                                            <div className="d-flex align-items-center mt-5">
                                                                <div className="loader mx-auto"></div>
                                                            </div>
                                                            :
                                                            <>
                                                                {(loading.tableLoading || loading.viewLoading) ?
                                                                    <div className="d-flex align-items-center mt-5">
                                                                        <div className="loader mx-auto"></div>
                                                                    </div>
                                                                    :
                                                                    allChallengeData.length > 0 ?
                                                                        allChallengeData.map((challengeData: CheckTheRhymeDataType, index: number) => (
                                                                            <div className='mb-4' key={challengeData.id} id={challengeData.id}>
                                                                                <div className="unitChallengeLists">
                                                                                    <div className="unitChallengeLists">
                                                                                        <div className='listHead'>
                                                                                            <div className="row mb-2">
                                                                                                {editCheckTheRhymeChallengeData.id === challengeData.id ? (
                                                                                                    <div className="col-10 form-group">
                                                                                                        <h6 className='highlightMediaText'>Add Rhyme Challenge <span className="text-danger">*</span></h6>
                                                                                                        <textarea rows={6} name="question"
                                                                                                            placeholder="Add Rhyme Challenge" value={editCheckTheRhymeChallengeData.checkTheRhyme.RhymeText} onChange={(e) => handleInputChange(e.target.value, -1, "question")} required />
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div className="col-10">
                                                                                                        <p className="quesText"><pre>{indexOfFirstItem + index + 1} - {challengeData.question}</pre></p>
                                                                                                    </div>
                                                                                                )}

                                                                                                {!editCheckTheRhymeChallengeData.id &&
                                                                                                    <div className="col-2">
                                                                                                        <div className="d-flex justify-content-end">
                                                                                                            <button className="btn" style={{ flexShrink: 0 }} type="button" data-bs-toggle="collapse" data-bs-target={`#challenge-${challengeData.id}`} aria-expanded="false" aria-controls={`challenge-${challengeData.id}`}>
                                                                                                                <img src="./assets/images/chevron-down-M.svg" alt="" />
                                                                                                            </button>


                                                                                                            <div className="dropdown dots">
                                                                                                                <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                                                                    <img src='./assets/images/more.svg' alt='action button' />
                                                                                                                </button>
                                                                                                                <ul className="dropdown-menu">

                                                                                                                    <li>
                                                                                                                        <button className="dropdown-item" onClick={() => handleEditChallenges(challengeData)} >
                                                                                                                            <img src="./assets/images/edit-icon.png" alt="" className="me-2" />
                                                                                                                            Edit
                                                                                                                        </button>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <button className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleDeleteChallengeById(challengeData.id)}>
                                                                                                                            <img src="./assets/images/delete.png" alt="" className="me-2" />
                                                                                                                            Delete
                                                                                                                        </button>
                                                                                                                    </li>
                                                                                                                </ul>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>}
                                                                                            </div>

                                                                                            {challengeData.id === editCheckTheRhymeChallengeData.id ?
                                                                                                <div className="form-group">
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-12">
                                                                                                            <h6 className='highlightMediaText'>Options (select the checkbox if corresponding option is the answer) <span className="text-danger">*</span></h6>
                                                                                                            {editCheckTheRhymeChallengeData.checkTheRhyme.Options.map((option: OptionDataType, optionIndex: number) => (
                                                                                                                <div className="form-group" key={`option-${optionIndex}`} >

                                                                                                                    <div className="row">



                                                                                                                        <div className="col-md-4 my-auto">
                                                                                                                            <input className="form-control w-100" type="text" id={`option-${optionIndex}`} value={option.optionText || ""} name={`option-${optionIndex}`} placeholder={`Option ${optionIndex + 1}`} onChange={(e) => handleInputChange(e.target.value, optionIndex, "option")} required />
                                                                                                                        </div>
                                                                                                                        <div className="col-md-6">
                                                                                                                            <div className="customImgUpload">
                                                                                                                                <div className="uploadBtn">
                                                                                                                                    {option.media.audio.files ?
                                                                                                                                        <div className="w-100">
                                                                                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                                <audio src={option.media.audio.blobPath} className="mx-auto" controls />
                                                                                                                                            </div>
                                                                                                                                            {option.media.audio.files !== option.media.audio.blobPath &&
                                                                                                                                                <div className="imgName">
                                                                                                                                                    {option.media.audio.files.name}
                                                                                                                                                </div>
                                                                                                                                            }
                                                                                                                                        </div>
                                                                                                                                        :
                                                                                                                                        <>
                                                                                                                                            <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                                                                            <label htmlFor={`audioFile${optionIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                                                                                            <input type="file" className="form-control d-none" id={`audioFile${optionIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleCTRMedia(e, "add", optionIndex)} required />
                                                                                                                                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a voice over audio.</div>
                                                                                                                                        </>
                                                                                                                                    }
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            {option.media.audio.files && <div className="row justify-content-center">
                                                                                                                                <div className="col-auto">
                                                                                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }}
                                                                                                                                        onClick={() => handleCTRMedia(null, "delete", optionIndex)}  >
                                                                                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                                                                                    </button>
                                                                                                                                </div>
                                                                                                                            </div>}
                                                                                                                        </div>


                                                                                                                        <div className='col-auto my-auto'>
                                                                                                                            <div className="d-flex justify-content-between h-100">
                                                                                                                                <input type="checkbox" className="ms-3 m-2" style={{ transform: "scale(1.5)" }} checked={option.isAnswer || false} onChange={(e) => handleInputChange(e.target.value, optionIndex, "answer")} />
                                                                                                                                {editCheckTheRhymeChallengeData.checkTheRhyme.Options.length > 1 && (
                                                                                                                                    <button className="btn" type="button" onClick={() => handleInputChange("", optionIndex, "delete")}>
                                                                                                                                        <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                                                                    </button>
                                                                                                                                )}
                                                                                                                                {editCheckTheRhymeChallengeData.checkTheRhyme.Options.length - 1 === optionIndex && (
                                                                                                                                    <button className="btn" type="button" onClick={() => handleInputChange("", optionIndex, "add")}>
                                                                                                                                        <img src="./assets/images/add-icon.svg" alt="add" />
                                                                                                                                    </button>
                                                                                                                                )}

                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>

                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                :
                                                                                                <div className="row">
                                                                                                    {challengeData.checkTheRhyme.Options.map((option: OptionDataType) => (
                                                                                                        <div key={option.id} className={`col-md-${12 / challengeData.checkTheRhyme.Options.length} mb-3`}
                                                                                                        >
                                                                                                            <pre className={`${option.isAnswer ? "greenText" : ""}`}
                                                                                                                style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{option.optionText}</pre>
                                                                                                        </div>
                                                                                                    ))
                                                                                                    }
                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className={challengeData.id === editCheckTheRhymeChallengeData.id ? "collapse show" : "collapse"} id={`challenge-${challengeData.id}`}>
                                                                                        <div className="card card-body bg-transparent" style={{ border: 0 }}>
                                                                                            {editCheckTheRhymeChallengeData.id === challengeData.id ?
                                                                                                <>


                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Hint <span className="text-danger">*</span></h6>
                                                                                                                <textarea rows={6} name="hintText"
                                                                                                                    style={{
                                                                                                                        border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden"
                                                                                                                    }} placeholder="Hint" value={editCheckTheRhymeChallengeData.checkTheRhyme.hintText} onChange={(e) => handleInputChange(e.target.value, -1, "hintText")} required />

                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Flip Rhyme Text <span className="text-danger">*</span></h6>
                                                                                                                <ReactQuill
                                                                                                                    className="whitebg"
                                                                                                                    id="flipText"
                                                                                                                    value={editCheckTheRhymeChallengeData.checkTheRhyme.flipRhymeText}
                                                                                                                    onChange={(value) => handleInputChange(value, -1, "flipText")}
                                                                                                                    style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                                                                                                    modules={{
                                                                                                                        toolbar: [
                                                                                                                            [{ header: [3, 4, false] }],
                                                                                                                            ["bold", "italic", "underline", "blockquote"],
                                                                                                                            [
                                                                                                                                { list: "ordered" },
                                                                                                                                { list: "bullet" },
                                                                                                                                { indent: "-1" },
                                                                                                                                { indent: "+1" }
                                                                                                                            ],
                                                                                                                            [{ align: [] }],
                                                                                                                            ["clean"]
                                                                                                                        ]
                                                                                                                    }}
                                                                                                                    formats={[
                                                                                                                        "bold", "italic", "underline", "blockquote",
                                                                                                                        "list", "bullet", "indent", "align"
                                                                                                                    ]}
                                                                                                                />


                                                                                                            </div>
                                                                                                        </div>


                                                                                                    </div>

                                                                                                    <div className="form-group">
                                                                                                        <h6 className='highlightMediaText'>Reward for the completion of this add the rhyme question  <span className="text-danger">*</span></h6>
                                                                                                        <input type='number' name="reward" className="form-control" placeholder="Reward" value={editCheckTheRhymeChallengeData.checkTheRhyme.reward} onChange={(e) => handleInputChange(e.target.value, -1, "reward")} onWheel={(e: any) => e.target.blur()} required />

                                                                                                    </div>

                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Rhyme Challenge VO <span className="text-danger">*</span></h6>
                                                                                                                <div className="customImgUpload">
                                                                                                                    <div className="uploadBtn">
                                                                                                                        {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files ?
                                                                                                                            <div className="w-100">
                                                                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                    <audio src={editCheckTheRhymeChallengeData.challengeMedia.audioFile.blobPath} className="mx-auto" controls />
                                                                                                                                    {/* <button type="button" className="bg-transparent" onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")} >
                                                                                                                                            <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                                                                        </button> */}

                                                                                                                                </div>
                                                                                                                                {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files !== editCheckTheRhymeChallengeData.challengeMedia.audioFile.blobPath &&
                                                                                                                                    <div className="imgName">
                                                                                                                                        {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files.name}
                                                                                                                                    </div>
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                            :
                                                                                                                            <>
                                                                                                                                <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                                                                <label htmlFor="audioFile">Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                                                                                <input type="file" className="form-control d-none" id="audioFile" name="audioFile" accept=".mp3, .wav" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                                                                            </>
                                                                                                                        }
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            {editCheckTheRhymeChallengeData.challengeMedia.audioFile.files && <div className="row justify-content-center">
                                                                                                                <div className="col-auto">
                                                                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")}>
                                                                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>}
                                                                                                        </div>
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Flip Rhyme Text VO <span className="text-danger">*</span></h6>
                                                                                                                <div className="customImgUpload">
                                                                                                                    <div className="uploadBtn">
                                                                                                                        {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files ?
                                                                                                                            <div className="w-100">
                                                                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                    <audio src={editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.blobPath} className="mx-auto" controls />
                                                                                                                                    {/* <button type="button" className="bg-transparent" onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")} >
                                                                                                                                            <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                                                                        </button> */}

                                                                                                                                </div>
                                                                                                                                {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files !== editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.blobPath &&
                                                                                                                                    <div className="imgName">
                                                                                                                                        {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files.name}
                                                                                                                                    </div>
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                            :
                                                                                                                            <>
                                                                                                                                <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                                                                <label htmlFor="rhymeAudioFile">Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                                                                                <input type="file" className="form-control d-none" id="rhymeAudioFile" name="rhymeAudioFile" accept=".mp3, .wav" onChange={(e) => handleChallengeMedia(e, "add")} />
                                                                                                                            </>
                                                                                                                        }
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            {editCheckTheRhymeChallengeData.challengeMedia.rhymeAudioFile.files && <div className="row justify-content-center">
                                                                                                                <div className="col-auto">
                                                                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "rhymeAudioFile")}>
                                                                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>}

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </> :
                                                                                                <>
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Hint</h6>
                                                                                                                <pre style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{challengeData.checkTheRhyme.hintText}</pre>

                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Flip Rhyme Text</h6>
                                                                                                                <p style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px" }} dangerouslySetInnerHTML={{ __html: challengeData.checkTheRhyme.flipRhymeText }} />
                                                                                                            </div>
                                                                                                        </div>


                                                                                                    </div>
                                                                                                    <div className="form-group">
                                                                                                        <h6 className='highlightMediaText'>Reward for the completion of this add the rhyme question</h6>
                                                                                                        <input type='number' name="reward" className="form-control" placeholder="Reward" value={challengeData.checkTheRhyme.reward} readOnly />

                                                                                                    </div>


                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Rhyme Challenge VO</h6>
                                                                                                                <div className="customImgUpload">
                                                                                                                    <div className="uploadBtn"><div className="w-100">
                                                                                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                            <audio src={challengeData.challengeMedia.audioFile.blobPath} className="mx-auto" controls />
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Flip Rhyme Text VO</h6>
                                                                                                                <div className="customImgUpload">
                                                                                                                    <div className="uploadBtn">
                                                                                                                        <div className="w-100">
                                                                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                <audio src={challengeData.challengeMedia.rhymeAudioFile.blobPath} className="mx-auto" controls />

                                                                                                                            </div>
                                                                                                                        </div>

                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            }





                                                                                            {editCheckTheRhymeChallengeData.id === challengeData.id &&
                                                                                                <div className="row justify-content-center" style={{ padding: "25px 0" }}>
                                                                                                    <div className="col-md-3">
                                                                                                        <div className="btn-group w-100">
                                                                                                            <button type="button" className="btn btn-save btnPurple" onClick={checkTheRhymeValidation} >Save</button>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-md-3">
                                                                                                        <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                                                                                                    </div>
                                                                                                </div>}
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        )) :
                                                                        (!loading.tableLoading && !loading.viewLoading && <p className="text-center mt-5">No Data Found</p>)
                                                                }

                                                            </>
                                                        }
                                                    </div>
                                                    <div className="pagination-container">
                                                        <nav className="d-flex justify-content-between">
                                                            <div className="page-length">
                                                                Showing {Math.min(indexOfFirstItem + 1, challengeCount)} - {Math.max(indexOfLastItem, challengeCount)} of {challengeCount}
                                                            </div>
                                                            <ul className="pagination justify-content-center mx-auto">
                                                                <li className="page-item">
                                                                    <button className="page-link" aria-label="Previous" onClick={() => handlePagination(currentPage - 1, 'left')}>
                                                                        <span aria-hidden="true"><img src="./assets/images/arrow-left-small.svg" alt="" /></span>
                                                                    </button>
                                                                </li>
                                                                <li className="page-item disabled">
                                                                    <span className="page-link">
                                                                        {indexOfFirstItem + 1} of {indexOfLastItem}
                                                                    </span>
                                                                </li>
                                                                <li className="page-item">
                                                                    <button className="page-link" aria-label="Next" onClick={() => handlePagination(currentPage + 1, 'right')}>
                                                                        <span aria-hidden="true"><img src="./assets/images/arrow-right-small.svg" alt="" /></span>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>


                                            </div>

                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id={`headingFour`}>
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseFour`} aria-expanded="false" aria-controls={`collapseFour`}>
                                                        Congratulations Screen
                                                    </button>
                                                </h2>
                                                <div id={`collapseFour`} className="accordion-collapse collapse" aria-labelledby={`headingFour`} data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <div className="form-group">
                                                            <div className="row">

                                                                <div className="col-md-6">
                                                                    <h6 className='highlightMediaText'>Congratulations Text <span className="text-danger">*</span></h6>
                                                                    <ReactQuill className='whitebg' onChange={(value) => handleCongratsInput(null, "congratulation-text", value, false)} value={editCheckTheRhymeChallengeData?.congratulation?.congratulationText || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                                                        modules={{
                                                                            toolbar: [
                                                                                [{ header: [3, 4, false] }],
                                                                                ["bold", "italic", "underline", "blockquote"],
                                                                                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                                                                [{ align: [] }]
                                                                            ]
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <h6 className='highlightMediaText'>Congratulations Voice Over <span className="text-danger">*</span></h6>
                                                                    {/* Audio Upload/Preview */}
                                                                    <div className="customImgUpload whitebg mb-3">
                                                                        <div className="uploadBtn">
                                                                            {editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files ? (
                                                                                <div className="w-100">
                                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                        <audio src={editCheckTheRhymeChallengeData.congratulation.congratulationAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                                    </div>
                                                                                    {editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files !== editCheckTheRhymeChallengeData.congratulation.congratulationAudio.blobPath && (
                                                                                        <div className="imgName">{editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files.name}</div>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                    <label htmlFor="congratulations-audio">
                                                                                        Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                                                    </label>
                                                                                    <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Replace Audio */}
                                                                    {editCheckTheRhymeChallengeData.congratulation.congratulationAudio.files && (
                                                                        <div className="row justify-content-center">
                                                                            <div className="col-auto">
                                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                                                                    <label className='m-0 flex' htmlFor="congratulations-audio" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                                                                        <img src="./assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                                                                        <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                                        Replace
                                                                                    </label>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>



                                                            </div>

                                                        </div>
                                                        <div className="d-flex justify-content-end mt-3 mb-3">
                                                            <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateCongratsData}>Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
</React.Fragment>

                                }


                            </div>

                        </div>
                    }

                </div>
            </div>

            {loading.deleteLoading &&
                <Loader message="Loading, Deleting Data..." />
            }
            {loading.fetchingLoading &&
                <Loader message="Loading, Fetching Data..." />
            }

            {loading.submitLoading &&
                <Loader message="Loading, Submitting Data..." />
            }

            {show &&
                <ConfirmationPopup
                    title={confirmationPopupData.title}
                    message={confirmationPopupData.message}
                    isBackIterated={true}
                    descriptions={confirmationPopupData.descriptions}
                    acceptText={confirmationPopupData.acceptText}
                    cancelText={confirmationPopupData.cancelText}
                    onAccept={confirmationPopupData.onAccept}
                    onCancel={confirmationPopupData.onCancel}
                    onCrossClick={confirmationPopupData.onCancel}
                />
            }
            {message.errorMessage.length > 0 &&
                <CustomAlert
                    errorCount={message.errorMessage.length}
                    messages={message.errorMessage}
                    onClose={() => { setMessage({ ...message, errorMessage: [] }); setValidated(false) }}
                />
            }

            <FullScreenLottieAnimation
                show={typeof previewSource === "string" && previewSource.trim() !== ""}
                animationPath={typeof previewSource === "string" ? previewSource : ""}
                onClose={handleClosePreview}
            />

        </div>
    );
};

export default CheckTheRhyme